{
  "account.account": "Профіль і безпека",
  "account.accountDeleted": "Ваш обліковий запис успішно видалено.",
  "account.accountDescription": "Ім'я, пароль, видалення облікового запису",
  "account.accountSection": "Обліковий запис",
  "account.changeEmail": "Змінити електронну пошту",
  "account.changePassword": "Змінити пароль",
  "account.currentPassword": "Поточний пароль",
  "account.dangerZone": "Небезпечна зона",
  "account.deleteAccount": "Видалити обліковий запис",
  "account.deleteAccountConfirmation": "Ви впевнені, що хочете видалити свій обліковий запис? Ця дія незворотна.",
  "account.deleteAccountDescription": "Ця дія видаляє ваш обліковий запис і всю вашу інформацію. Дороги назад немає.",
  "account.emailChange": "Змінити адресу електронної пошти",
  "account.emailChangeConfirmation": "Підтвердження зміни електронної пошти",
  "account.emailChangeFailure": "Посилання для зміни електронної пошти недійсне або закінчилося.",
  "account.emailChangeIntro": "Введіть нову адресу електронної пошти та поточний пароль. Ми надішлемо посилання на нову адресу: адреса зміниться лише після того, як ви його відкриєте.",
  "account.emailChangeSuccess": "Вашу електронну пошту успішно змінено на {newEmail}.",
  "account.emailChangeSuccessNoAddress": "Вашу адресу електронної пошти успішно змінено.",
  "account.emailChangeVerificationSent": "Лист для підтвердження надіслано на вашу нову адресу електронної пошти. Перевірте вхідні повідомлення та натисніть на посилання, щоб підтвердити зміну.",
  "account.manageAccount": "Керувати обліковим записом",
  "account.newEmailAddress": "Нова адреса електронної пошти",
  "account.newPassword": "Новий пароль",
  "account.newPasswordAgain": "Повторіть новий пароль",
  "account.oldPassword": "Старий пароль",
  "account.passwordChange": "Зміна пароля",
  "account.passwordChangeDescription": "Захистіть свій обліковий запис",
  "account.passwordUpdated": "Пароль успішно оновлено.",
  "account.profile": "Профіль",
  "account.profileUpdated": "Профіль успішно оновлено.",
  "account.signedInAs": "Ви увійшли як",
  "account.updateYourProfile": "Оновіть свій профіль",
  "account.updateYourProfileDescription": "Ім'я та параметри відображення",
  "addons.accountOnHold": "З'єднання вашого облікового запису закінчилося. Будь ласка, підключіться знову, щоб відновити оновлення даних.",
  "addons.accountOnHoldTitle": "Обліковий запис призупинено",
  "addons.ambientWeatherCreateAndRetrieveApiKey": "Створіть і отримайте свій ключ API за цим посиланням",
  "addons.ambientWeatherDescription": "Метеостанції Ambient Weather (WS-5000, WS-2000, WS-2902C,...)",
  "addons.apiKey": "Ключ API",
  "addons.applicationKey": "Ключ програми",
  "addons.availableServices": "Доступні",
  "addons.cannotDisconnectLastAccount": "Неможливо від'єднати єдиний метод входу. Спочатку додайте інший метод входу.",
  "addons.connect": "Підключити",
  "addons.connected": "Підключено",
  "addons.connectedAccounts": "Підключені облікові записи",
  "addons.connectedAccountsDescription": "Apple, Google, Facebook",
  "addons.connectedServices": "Підключено",
  "addons.connectedSince": "Підключено з {date}",
  "addons.connectionSection": "Підключення",
  "addons.connectionSuccess": "Акаунт {provider} успішно підключено",
  "addons.davisApiSecret": "Секрет API",
  "addons.davisApiV2Key": "Ключ API V2",
  "addons.davisDescription": "Метеостанції Davis (Vantage Vue, Vantage Pro2,...)",
  "addons.davisRetrieveApiKey": "Отримайте свої ключі API V2 за цим посиланням",
  "addons.disconnect": "Від'єднати",
  "addons.disconnectConfirmation": "Ви впевнені, що хочете від'єднати свій акаунт {provider}?",
  "addons.disconnectionSuccess": "Акаунт {provider} успішно від'єднано",
  "addons.disconnectProviderDescription": "Зупиняє синхронізацію. Вашу історію збережено.",
  "addons.ecowittCreateAndRetrieveKeys": "Створіть і отримайте як ключ API, так і ключ програми за цим посиланням",
  "addons.ecowittDescription": "Ecowitt пропонує професійну метеостанцію Wi-Fi, бездротові термометри для приміщень і вулиці, монітори вологості, високоточні датчики дощу, монітори якості повітря тощо.",
  "addons.helpLink": "Як підключити {provider}",
  "addons.integrationsSection": "Інтеграції",
  "addons.myAcuriteAccountOnHold": "Ваш обліковий запис призупинено. Будь ласка, введіть свій пароль, щоб повторно підключити обліковий запис",
  "addons.myAcuriteDescription": "AcuRite є брендом метеостанцій №1 у Північній Америці. Будучи лідером у галузі технологій часу, температури та погоди, AcuRite надає вам детальну інформацію про ваше середовище в приміщенні та на вулиці, щоб ви могли впевнено планувати свій день.",
  "addons.netatmoEnergy": "Netatmo Energy",
  "addons.netatmoEnergyDescription": "Використовуйте свій термостат Netatmo, щоб змінювати температуру вдома, перебуваючи в ліжку чи з іншого боку світу.",
  "addons.netatmoWeather": "Netatmo Weather",
  "addons.netatmoWeatherDescription": "Ваша персональна метеостанція вдома",
  "addons.notConnected": "Не підключено",
  "addons.or": "або",
  "addons.providerAccountDisconnected": "З'єднання з вашою метеослужбою закінчилося. Будь ласка, підключіться знову, щоб відновити оновлення даних.",
  "addons.reconnect": "Повторне підключення",
  "addons.socialConnectionsIntro": "Підключіть свої соціальні акаунти для швидкого входу. Ви можете підключати або від'єднувати акаунти в будь-який час.",
  "addons.weatherflowCreateToken": "Створіть і отримайте свій маркер за цим посиланням",
  "addons.weatherflowTempestDescription": "Система Tempest Weather із вбудованим вітроміром і дощоміром",
  "addons.weatherServices": "Метеорологічні сервіси",
  "addons.weatherServicesConnected": "{count, plural, =0 {Немає підключених сервісів} one {# сервіс підключено} few {# сервіси підключено} many {# сервісів підключено} other {# сервісів підключено}}",
  "addons.weatherServicesDescription": "Підключіть Netatmo, Davis, Weatherflow та інші",
  "addons.wundergroundApiKey": "Ключ API",
  "addons.wundergroundDescription": "Weather Underground — це глобальна спільнота людей, які об’єднують дані з датчиків навколишнього середовища, як-от метеостанцій і моніторів якості повітря, щоб ми могли надавати різноманітні гіперлокальні дані, необхідні для ваших пристрастей",
  "addons.wundergroundRetrieveApiKey": "Отримайте свій ключ API за цим посиланням",
  "addons.wundergroundStationId": "ID станції",
  "airQuality.adviceActivityGood": "Ідеальний день для активності на вулиці",
  "airQuality.adviceActivityHazardous": "Уникайте будь-якої фізичної активності на вулиці",
  "airQuality.adviceActivityLabel": "Фізична активність",
  "airQuality.adviceActivityModerate": "Гарний день для активності на вулиці",
  "airQuality.adviceActivitySensitive": "Подумайте про коротші та менш інтенсивні заняття на вулиці",
  "airQuality.adviceActivityUnhealthy": "Скоротіть тривалі або інтенсивні заняття й частіше робіть перерви",
  "airQuality.adviceActivityVeryUnhealthy": "Уникайте тривалих або інтенсивних занять; за можливості перенесіть їх у приміщення",
  "airQuality.adviceGroupsGood": "Особливих запобіжних заходів не потрібно",
  "airQuality.adviceGroupsHazardous": "Залишайтеся в приміщенні та знизьте активність",
  "airQuality.adviceGroupsLabel": "Чутливі групи",
  "airQuality.adviceGroupsModerate": "Особливо чутливим людям: коротші та менш інтенсивні заняття",
  "airQuality.adviceGroupsSensitive": "Коротші та менш інтенсивні заняття на вулиці, з частішими перервами",
  "airQuality.adviceGroupsUnhealthy": "Уникайте тривалих або інтенсивних занять на вулиці; за можливості перенесіть їх у приміщення",
  "airQuality.adviceGroupsVeryUnhealthy": "Уникайте будь-якої фізичної активності на вулиці; відкладіть її або перенесіть у приміщення",
  "airQuality.adviceTimingLabel": "Коли виходити",
  "airQuality.adviceTimingMorning": "Найкраще вранці — тоді озону менше",
  "airQuality.airQuality": "Якість повітря",
  "airQuality.airQualityIndex": "Індекс якості повітря",
  "airQuality.aqiForecast": "Прогноз якості повітря",
  "airQuality.co2Fresh": "Свіже",
  "airQuality.co2GettingStale": "Трохи задушливо",
  "airQuality.co2Stale": "Задушливо",
  "airQuality.dailyForecast": "Щоденний прогноз",
  "airQuality.dominantPollutant": "Основний забруднювач",
  "airQuality.expectedPeak": "Очікуваний пік",
  "airQuality.good": "Добрий",
  "airQuality.goodDescription": "Якість повітря вважається задовільною, а забруднення повітря становить незначний ризик або не становить його взагалі",
  "airQuality.hazardous": "Небезпечний",
  "airQuality.hazardousDescription": "Попередження про здоров’я: будь-хто може мати більш серйозні наслідки для здоров’я",
  "airQuality.indoorAirQuality": "Якість повітря в приміщенні",
  "airQuality.moderate": "Помірний",
  "airQuality.moderateDescription": "Якість повітря прийнятна; однак деякі забруднювачі можуть викликати помірне занепокоєння для здоров'я дуже невеликої кількості людей, які надзвичайно чутливі до забруднення повітря.",
  "airQuality.noForecastForLocation": "Прогноз якості повітря для цього місця недоступний.",
  "airQuality.now": "Зараз",
  "airQuality.nowCastAqi": "NowCast AQI",
  "airQuality.pollutants": "Забруднювачі",
  "airQuality.recommendations": "Рекомендації",
  "airQuality.sensitiveUnhealthy": "Нездоровий для чутливих груп",
  "airQuality.sensitiveUnhealthyDescription": "Члени чутливих груп можуть мати наслідки для здоров'я. Це навряд чи вплине на широку громадськість.",
  "airQuality.subIndex": "Субіндекс AQI",
  "airQuality.ugm3": "µg/m³",
  "airQuality.understandIndex": "Як читати індекс",
  "airQuality.unhealthy": "Нездоровий",
  "airQuality.unhealthyDescription": "Кожен може почати відчувати вплив на здоров'я; члени чутливих груп можуть мати більш серйозні наслідки для здоров'я",
  "airQuality.veryUnhealthy": "Дуже нездоровий",
  "airQuality.veryUnhealthyDescription": "Медичні попередження про надзвичайні ситуації. Більша ймовірність ураженості всього населення.",
  "alerts.addAlert": "Додати сповіщення",
  "alerts.addCondition": "Додайте умову",
  "alerts.alertAdded": "Сповіщення успішно додано",
  "alerts.alertAuthorizationNotice": "Сповіщення працюють, лише якщо ви дозволили SmartMixin відображати сповіщення",
  "alerts.alertDeleted": "Сповіщення успішно видалено",
  "alerts.alertName": "Назва сповіщення",
  "alerts.alertWhen": "Я хочу отримувати сповіщення, коли:",
  "alerts.aqiGreaterThan": "AQI більше ніж",
  "alerts.aqiGreaterThanThreshold": "AQI перевищує порогове значення {value}{unit}",
  "alerts.aqiLessThan": "AQI менше ніж",
  "alerts.aqiLessThanThreshold": "AQI менший за порогове значення {value}{unit}",
  "alerts.atLeastOneCondition": "Потрібно додати хоча б одну умову",
  "alerts.co2GreaterThan": "CO2 більше ніж",
  "alerts.co2GreaterThanThreshold": "CO2 перевищує порогове значення {value}{unit}",
  "alerts.co2LessThan": "CO2 менше ніж",
  "alerts.co2LessThanThreshold": "CO2 менший за порогове значення {value}{unit}",
  "alerts.conditions": "Умови",
  "alerts.conditionsDroppedOnStationChange": "Не підтримується цією станцією, видалено: {conditions}",
  "alerts.createAlert": "Створити сповіщення",
  "alerts.dailyPrecipitationGreaterThan": "Добові опади більше ніж",
  "alerts.dailyPrecipitationGreaterThanThreshold": "Добові опади перевищують поріг {value}{unit}",
  "alerts.deleteAlert": "Видалити сповіщення",
  "alerts.editAlert": "Редагувати сповіщення",
  "alerts.editCondition": "Редагувати умову",
  "alerts.gustSpeedGreaterThan": "Швидкість пориву більше ніж",
  "alerts.gustSpeedGreaterThanThreshold": "Швидкість поривів перевищує порогове значення {value}{unit}",
  "alerts.gustSpeedLessThan": "Швидкість пориву менше ніж",
  "alerts.gustSpeedLessThanThreshold": "Швидкість поривів менша за порогове значення {value}{unit}",
  "alerts.heatIndexGreaterThan": "Індекс тепла більший за",
  "alerts.heatIndexGreaterThanThreshold": "Індекс тепла перевищує порогове значення {value}{unit}",
  "alerts.heatIndexLessThan": "Індекс тепла менший за",
  "alerts.heatIndexLessThanThreshold": "Індекс тепла нижчий за порогове значення {value}{unit}",
  "alerts.humidexGreaterThan": "Гумідекс більший за",
  "alerts.humidexGreaterThanThreshold": "Гумідекс перевищує порогове значення {value}{unit}",
  "alerts.humidexLessThan": "Гумідекс менший за",
  "alerts.humidexLessThanThreshold": "Гумідекс нижчий за порогове значення {value}{unit}",
  "alerts.humidityGreaterThan": "Вологість більше ніж",
  "alerts.humidityGreaterThanThreshold": "Вологість перевищує порогове значення {value}{unit}",
  "alerts.humidityLessThan": "Вологість менше ніж",
  "alerts.humidityLessThanThreshold": "Вологість менше ніж порогове значення {value}{unit}",
  "alerts.inProgress": "В процесі",
  "alerts.leafWetnessGreaterThan": "Вологість листя більше ніж",
  "alerts.leafWetnessGreaterThanThreshold": "Вологість листя перевищує порогове значення {value}{unit}",
  "alerts.leafWetnessLessThan": "Вологість листя менше ніж",
  "alerts.leafWetnessLessThanThreshold": "Вологість листя менше ніж порогове значення {value}{unit}",
  "alerts.myAlerts": "Мої сповіщення",
  "alerts.noConfiguredAlert": "У вас ще немає налаштованих сповіщень, почніть додавати одне",
  "alerts.noiseGreaterThan": "Шум більше ніж",
  "alerts.noiseGreaterThanThreshold": "Шум перевищує порогове значення {value}{unit}",
  "alerts.noiseLessThan": "Шум менше ніж",
  "alerts.noiseLessThanThreshold": "Шум менше порогового значення {value}{unit}",
  "alerts.noteOnConditions": "Зауважте, що сповіщення спрацьовує, коли перевіряються всі наведені нижче умови",
  "alerts.noTriggerHistory": "Це сповіщення ще не спрацьовувало.",
  "alerts.pm10GreaterThan": "PM 10 більше ніж",
  "alerts.pm10GreaterThanThreshold": "PM 10 перевищує порогове значення {value}{unit}",
  "alerts.pm10LessThan": "PM 10 менше ніж",
  "alerts.pm10LessThanThreshold": "PM 10 менше за порогове значення {value}{unit}",
  "alerts.pm1GreaterThan": "PM 1 більше ніж",
  "alerts.pm1GreaterThanThreshold": "PM 1 перевищує порогове значення {value}{unit}",
  "alerts.pm1LessThan": "PM 1 менше ніж",
  "alerts.pm1LessThanThreshold": "PM 1 менше за порогове значення {value}{unit}",
  "alerts.pm2p5GreaterThan": "PM 2,5 більше ніж",
  "alerts.pm2p5GreaterThanThreshold": "PM 2,5 перевищує порогове значення {value}{unit}",
  "alerts.pm2p5LessThan": "PM 2,5 менше ніж",
  "alerts.pm2p5LessThanThreshold": "PM 2,5 менше ніж порогове значення {value}{unit}",
  "alerts.postStormSummary": "Підсумок після дощу",
  "alerts.postStormSynopsisHelper": "Ви отримаєте сповіщення з підсумком після завершення кожного дощу.",
  "alerts.postStormSynopsisSoleCondition": "Підсумок після дощу не можна поєднувати з іншими умовами.",
  "alerts.precipitationGreaterThan": "Годинні опади більше ніж",
  "alerts.precipitationGreaterThanThreshold": "Годинні опади перевищують поріг {value}{unit}",
  "alerts.pressureGreaterThan": "Тиск більше ніж",
  "alerts.pressureGreaterThanThreshold": "Тиск перевищує порогове значення {value}{unit}",
  "alerts.pressureLessThan": "Тиск менше ніж",
  "alerts.pressureLessThanThreshold": "Тиск менший за порогове значення {value}{unit}",
  "alerts.rainRateGreaterThan": "Інтенсивність дощу більше ніж",
  "alerts.rainRateGreaterThanThreshold": "Інтенсивність дощу перевищує поріг {value}{unit}",
  "alerts.sensorNotReporting": "Цей датчик зараз не передає дані. Сповіщення відновиться, коли він знову почне їх передавати.",
  "alerts.soilMoistureGreaterThan": "Вологість ґрунту більше ніж",
  "alerts.soilMoistureGreaterThanThreshold": "Вологість ґрунту перевищує порогове значення {value}{unit}",
  "alerts.soilMoistureLessThan": "Вологість ґрунту менше ніж",
  "alerts.soilMoistureLessThanThreshold": "Вологість ґрунту менше ніж порогове значення {value}{unit}",
  "alerts.solarRadiationGreaterThan": "Сонячна радіація більше ніж",
  "alerts.solarRadiationGreaterThanThreshold": "Сонячна радіація перевищує порогове значення {value}{unit}",
  "alerts.solarRadiationLessThan": "Сонячна радіація менше ніж",
  "alerts.solarRadiationLessThanThreshold": "Сонячна радіація менша за порогове значення {value}{unit}",
  "alerts.stormChartUnavailable": "Історія опадів для цього дощу недоступна.",
  "alerts.stormDetail": "Підсумок дощу",
  "alerts.stormDuration": "Тривалість",
  "alerts.stormEnd": "Кінець",
  "alerts.stormPeakRate": "Максимальна інтенсивність дощу",
  "alerts.stormStart": "Початок",
  "alerts.stormTotal": "Загальна кількість опадів",
  "alerts.temperatureGreaterThan": "Температура вище ніж",
  "alerts.temperatureGreaterThanThreshold": "Температура перевищує порогове значення {value}{unit}",
  "alerts.temperatureLessThan": "Температура менше ніж",
  "alerts.temperatureLessThanThreshold": "Температура нижча за порогове значення {value}{unit}",
  "alerts.thresholdOutOfRange": "Має бути між {min} та {max}",
  "alerts.thswGreaterThan": "THSW більший за",
  "alerts.thswGreaterThanThreshold": "THSW перевищує порогове значення {value}{unit}",
  "alerts.thswLessThan": "THSW менший за",
  "alerts.thswLessThanThreshold": "THSW нижчий за порогове значення {value}{unit}",
  "alerts.thwGreaterThan": "THW більший за",
  "alerts.thwGreaterThanThreshold": "THW перевищує порогове значення {value}{unit}",
  "alerts.thwLessThan": "THW менший за",
  "alerts.thwLessThanThreshold": "THW нижчий за порогове значення {value}{unit}",
  "alerts.triggerHistory": "Історія сповіщення",
  "alerts.uvGreaterThan": "УФ-індекс більше ніж",
  "alerts.uvGreaterThanThreshold": "УФ-індекс перевищує порогове значення {value}{unit}",
  "alerts.uvLessThan": "УФ-індекс менше ніж",
  "alerts.uvLessThanThreshold": "УФ-індекс менший за порогове значення {value}{unit}",
  "alerts.visibilityGreaterThanThreshold": "Видимість перевищує порогове значення {value}{unit}",
  "alerts.visibilityLessThanThreshold": "Видимість менше ніж порогове значення {value}{unit}",
  "alerts.visiblityGreaterThan": "Видимість більше ніж",
  "alerts.visiblityLessThan": "Видимість менше ніж",
  "alerts.whichMeasure": "Для якого показника ви хочете отримувати сповіщення?",
  "alerts.whichModule": "Для якого модуля ви хочете отримувати сповіщення?",
  "alerts.whichSensor": "Для якого датчика ви хочете отримувати сповіщення?",
  "alerts.windChillGreaterThan": "Вітро-холодовий індекс більший за",
  "alerts.windChillGreaterThanThreshold": "Вітро-холодовий індекс перевищує порогове значення {value}{unit}",
  "alerts.windChillLessThan": "Вітро-холодовий індекс менший за",
  "alerts.windChillLessThanThreshold": "Вітро-холодовий індекс нижчий за порогове значення {value}{unit}",
  "alerts.windSpeedGreaterThan": "Швидкість вітру більше ніж",
  "alerts.windSpeedGreaterThanThreshold": "Швидкість вітру перевищує порогове значення {value}{unit}",
  "alerts.windSpeedLessThan": "Швидкість вітру менше ніж",
  "alerts.windSpeedLessThanThreshold": "Швидкість вітру менша за порогове значення {value}{unit}",
  "appUpdate.updateAvailable": "Доступне оновлення",
  "appUpdate.updateAvailableOpenAppStore": "Торкніться, щоб відкрити App Store",
  "appUpdate.updateAvailableOpenGooglePlay": "Торкніться, щоб відкрити Google Play",
  "appUpdate.updateAvailableVersion": "Доступне оновлення: v{version}",
  "appUpdate.upgradeRequiredAndroid": "Необхідно оновити вашу програму. Щоб оновити, відвідайте Google Play.",
  "appUpdate.upgradeRequiredIos": "Необхідно оновити вашу програму. Щоб оновити, відвідайте App Store.",
  "astral.aboveHorizonAllDay": "Увесь день над горизонтом",
  "astral.aboveTheHorizon": "над горизонтом",
  "astral.apparentSize": "Видимий розмір",
  "astral.apparentSizeAcross": "{size} у поперечнику",
  "astral.astronomicalDawn": "Астрономічний світанок",
  "astral.astronomicalDusk": "Астрономічні сутінки",
  "astral.belowHorizonAllDay": "Увесь день під горизонтом",
  "astral.belowHorizonSince": "Під горизонтом з {time}",
  "astral.belowHorizonSinceOn": "Під горизонтом з {day} {time}",
  "astral.brightAllNight": "Світло всю ніч — темрява не настає",
  "astral.brightestMoment": "Найсвітліший момент",
  "astral.civilDawn": "Цивільний світанок",
  "astral.civilDusk": "Цивільні сутінки",
  "astral.darkSkyBetween": "Темне небо {from} → {to}",
  "astral.darkSkyWindow": "Темне небо {from} → {to} · {duration} без Місяця",
  "astral.dayLength": "Тривалість дня",
  "astral.daylightThroughTheYear": "Тривалість дня протягом року",
  "astral.dayOfCycle": "день {day} з {total}",
  "astral.doesNotOccurToday": "Сьогодні не настає",
  "astral.domeHint": "Потягніть, щоб пройти крізь ніч",
  "astral.domeReadout": "{time} · {altitude} · {direction}",
  "astral.earliestSunrise": "Найраніший схід сонця",
  "astral.earliestSunset": "Найраніший захід сонця",
  "astral.equinox": "Рівнодення",
  "astral.equinoxIn": "Рівнодення через {days, plural, one {# день} few {# дні} many {# днів} other {# дня}}",
  "astral.evening": "Вечір",
  "astral.exactPhaseAt": "Точно о {time}",
  "astral.firstQuarter": "Перша чверть",
  "astral.firstSunriseIn": "Перший схід сонця через {days, plural, one {# день} few {# дні} many {# днів} other {# дня}}",
  "astral.firstSunsetIn": "Перший захід сонця через {days, plural, one {# день} few {# дні} many {# днів} other {# дня}}",
  "astral.fullMoon": "Повний місяць",
  "astral.goldenHourBegins": "Початок золотої години",
  "astral.goldenHourEnds": "Кінець золотої години",
  "astral.highestPoint": "Найвища точка",
  "astral.inDays": "через {days, plural, one {# день} few {# дні} many {# днів} other {# дня}}",
  "astral.lastQuarter": "Остання чверть",
  "astral.latestSunrise": "Найпізніший схід сонця",
  "astral.latestSunset": "Найпізніший захід сонця",
  "astral.litShort": "Освітл.",
  "astral.longestDay": "Найдовший день",
  "astral.lowestPoint": "Найнижча точка",
  "astral.maxAltitudeShort": "Макс.",
  "astral.midday": "Полудень",
  "astral.midnightSun": "Полярний день",
  "astral.midnightSunPeriod": "Полярний день",
  "astral.milestoneFootnotePolar": "Тут сонце {days, plural, one {# день} few {# дні} many {# днів} other {# дня}} на рік не сходить і не заходить, тому замість звичних крайніх сходів і заходів список показує, коли це відбувається.",
  "astral.milestoneFootnoteTemperate": "Найраніший захід і найпізніший схід не припадають на найкоротший день — ці дві дати задає рівняння часу, а не сонцестояння.",
  "astral.moon": "Місяць",
  "astral.moonAltitude": "Висота",
  "astral.moonDirection": "Азимут",
  "astral.moonDistance": "Відстань",
  "astral.moonlessFor": "{duration} без Місяця",
  "astral.moonPhases": "Місячні фази",
  "astral.moonrise": "Схід місяця",
  "astral.moonset": "Захід місяця",
  "astral.moonUpAllNight": "Місяць над горизонтом усю ніч",
  "astral.moonWashesOutNight": "Місяць над горизонтом з {rise} до {set} і засвічує всю ніч",
  "astral.morning": "Ранок",
  "astral.nauticalDawn": "Навігаційний світанок",
  "astral.nauticalDusk": "Навігаційні сутінки",
  "astral.newMoon": "Новий місяць",
  "astral.nextDay": "+1 день",
  "astral.nextProperlyDarkNight": "Наступна справді темна ніч",
  "astral.nextRise": "наступний схід о {time}",
  "astral.nextRiseOn": "наступний схід {day} о {time}",
  "astral.nextSevenNights": "Наступні сім ночей",
  "astral.noAstronomicalDarknessTonight": "Цієї ночі немає астрономічної темряви",
  "astral.noDarkNightAhead": "Немає в найближчі два тижні",
  "astral.noSunriseToday": "Сьогодні сонце не сходить",
  "astral.nowAtBearing": "зараз {altitude} · азимут {direction}",
  "astral.observing": "Спостереження",
  "astral.ofDaylightLeft": "світлового дня залишилось",
  "astral.overTheNextThreeWeeks": "за наступні 3 тижні",
  "astral.percentLit": "{percent} освітлено",
  "astral.polarNight": "Полярна ніч",
  "astral.polarNightPeriod": "Полярна ніч",
  "astral.rightNow": "Зараз",
  "astral.riseShort": "Схід",
  "astral.setShort": "Захід",
  "astral.shortestDay": "Найкоротший день",
  "astral.solarNoon": "Сонячний полудень",
  "astral.solstice": "Сонцестояння",
  "astral.sunBelowHorizon": "Сонце на {degrees}° нижче горизонту",
  "astral.sunEvents": "Сонячні події",
  "astral.sunNeverDarkEnough": "Сонце не опускається на 18° нижче горизонту",
  "astral.sunNeverSets": "Сонце не заходить",
  "astral.sunrise": "Схід сонця",
  "astral.sunriseAndSunset": "Схід і захід сонця",
  "astral.sunriseAt": "Схід сонця о {time}",
  "astral.sunset": "Захід сонця",
  "astral.sunsetAt": "Захід сонця о {time}",
  "astral.thisYearAtNorth": "Цього року на {degrees}° пн. ш.",
  "astral.thisYearAtSouth": "Цього року на {degrees}° пд. ш.",
  "astral.tonight": "Цієї ночі",
  "astral.twilightAllNight": "Сутінки всю ніч — темрява не настає",
  "astral.upFor": "{duration} над горизонтом",
  "astral.usableLight": "Світлий час",
  "astral.vsAverage": "{percent} від середнього",
  "astral.vsYesterday": "порівняно з учорашнім днем",
  "astral.waningCrescent": "Спадний серп",
  "astral.waningGibbous": "Спадний місяць",
  "astral.waxingCrescent": "Зростаючий серп",
  "astral.waxingGibbous": "Зростаючий місяць",
  "astral.whereToLook": "Куди дивитися",
  "astral.withoutTheMoon": "{duration} без Місяця",
  "auth.alreadyHaveAccount": "Вже маєте обліковий запис?",
  "auth.authContainerTagline": "Ваша персональна панель погоди. Підключіть свої станції та отримуйте дані в реальному часі під рукою.",
  "auth.backToLogin": "Повернутися до входу",
  "auth.checkYourEmail": "Перевірте вашу електронну пошту",
  "auth.continueWithApple": "Продовжити з Apple",
  "auth.continueWithFacebook": "Продовжити з Facebook",
  "auth.continueWithGoogle": "Продовжити з Google",
  "auth.email": "Адреса електронної пошти",
  "auth.emailRequiredLoginFacebook": "Потрібен дозвіл електронної пошти.",
  "auth.emailVerification": "Підтвердження електронної пошти",
  "auth.emailVerificationFailure": "Виникла проблема з підтвердженням електронної пошти.",
  "auth.emailVerificationSuccess": "Вашу електронну адресу було успішно підтверджено.",
  "auth.firstName": "Ім'я",
  "auth.forgotPassword": "Забули свій пароль?",
  "auth.forgotPasswordSubtitle": "Введіть вашу електронну пошту, і ми надішлемо вам посилання для скидання пароля.",
  "auth.lastName": "Прізвище",
  "auth.login": "Увійти",
  "auth.loginSubtitle": "З поверненням! Будь ласка, введіть свої дані.",
  "auth.loginToSmartMixinDescription": "Увійдіть у SmartMixin, щоб отримати доступ до своїх метеостанцій, переглядати аналітику та керувати особистою панеллю погоди.",
  "auth.logout": "Вийти",
  "auth.logoutConfirmation": "Вийти з облікового запису?",
  "auth.noAccountYet": "Ще немає облікового запису?",
  "auth.or": "або",
  "auth.password": "Пароль",
  "auth.passwordReset": "Скидання пароля",
  "auth.passwordResetSuccess": "Ваш пароль успішно оновлено.",
  "auth.register": "Створити акаунт",
  "auth.registerDescription": "Створіть безкоштовний обліковий запис SmartMixin для підключення ваших метеостанцій, відстеження погодних даних та доступу до потужних аналітичних інструментів.",
  "auth.registerSubtitle": "Створіть обліковий запис, щоб почати.",
  "auth.restorePassword": "Відновити пароль",
  "auth.restorePasswordSuccess": "Ми щойно надіслали вам посилання для зміни пароля на адресу {emailAddress} із подальшими інструкціями.",
  "auth.sendReset": "Надіслати інструкції щодо скидання",
  "auth.signInWithApple": "Увійти з Apple",
  "auth.socialAccount": "або скористайтеся своїм обліковим записом",
  "auth.staffVerificationCode": "Код підтвердження",
  "auth.staffVerificationExpiresIn": "Підтверджено. Спливає через {duration}.",
  "auth.staffVerificationInvalidCode": "Неправильний код. Спробуйте ще раз.",
  "auth.staffVerificationLoginAsStopped": "Login As зупинено: щоб продовжити, введіть код підтвердження на екрані Debug.",
  "auth.staffVerificationNotEnrolled": "Для вашого облікового запису не налаштовано застосунок автентифікації. Додайте його в налаштуваннях безпеки панелі адміністратора.",
  "auth.staffVerificationPrompt": "Введіть 6-значний код із застосунку автентифікації або код відновлення, щоб користуватися Login As і пошуком користувачів.",
  "auth.staffVerificationSetupLink": "Додати застосунок автентифікації",
  "auth.staffVerificationSubmit": "Підтвердити",
  "auth.staffVerificationTitle": "Перевірка працівника",
  "calendar.afternoon": "День",
  "calendar.april": "Квітень",
  "calendar.august": "Серпень",
  "calendar.changePeriod": "Період: {period}. Змінити період",
  "calendar.currentDay": "Поточний день",
  "calendar.dateFormat": "Формат дати",
  "calendar.day": "День",
  "calendar.december": "Грудень",
  "calendar.durationHours": "{hours} год",
  "calendar.durationHoursMinutes": "{hours} год {minutes} хв",
  "calendar.durationMinutes": "{minutes} хв",
  "calendar.durationMinutesSeconds": "{minutes} хв {seconds} с",
  "calendar.durationSeconds": "{seconds} с",
  "calendar.end": "Кінець",
  "calendar.endTime": "Час закінчення",
  "calendar.evening": "Вечір",
  "calendar.february": "Лютий",
  "calendar.goToNextDay": "Наступний день",
  "calendar.goToNextMonth": "Наступний місяць",
  "calendar.goToNextWeek": "Наступний тиждень",
  "calendar.goToNextYear": "Наступний рік",
  "calendar.goToPreviousDay": "Попередній день",
  "calendar.goToPreviousMonth": "Попередній місяць",
  "calendar.goToPreviousWeek": "Попередній тиждень",
  "calendar.goToPreviousYear": "Попередній рік",
  "calendar.hour": "Година",
  "calendar.hoursCount": "{count, plural, one {# година} few {# години} many {# годин} other {# години}}",
  "calendar.hoursShort": "год",
  "calendar.hoursShortCount": "{count, plural, one {# год} few {# год} many {# год} other {# год}}",
  "calendar.january": "Січень",
  "calendar.july": "Липень",
  "calendar.june": "Червень",
  "calendar.last12Hours": "Останні 12 годин",
  "calendar.last24Hours": "Останні 24 години",
  "calendar.last30Days": "Останні 30 днів",
  "calendar.last3Hours": "Останні 3 години",
  "calendar.last6Hours": "Останні 6 годин",
  "calendar.last7Days": "Останні 7 днів",
  "calendar.lastHour": "Остання година",
  "calendar.march": "Березень",
  "calendar.max": "Макс",
  "calendar.may": "Травень",
  "calendar.month": "Місяць",
  "calendar.monthTotal": "Усього за місяць",
  "calendar.morning": "Ранок",
  "calendar.nextHours": "Наступні години",
  "calendar.night": "Ніч",
  "calendar.november": "Листопад",
  "calendar.october": "Жовтень",
  "calendar.oneDay": "1 день",
  "calendar.oneHour": "1 година",
  "calendar.oneMonth": "1 місяць",
  "calendar.oneWeek": "1 тиждень",
  "calendar.periodRangeSpoken": "з {start} по {end}",
  "calendar.previous24Hours": "Попередні 24 години",
  "calendar.previous30Days": "Попередні 30 днів",
  "calendar.previous7Days": "Попередні 7 днів",
  "calendar.previousDay": "Попередній день",
  "calendar.previousHours": "Попередні години",
  "calendar.previousMonth": "Попередній місяць",
  "calendar.previousWeek": "Попередній тиждень",
  "calendar.previousYear": "Попередній рік",
  "calendar.sameDayLastYear": "Той же день минулого року",
  "calendar.sameMonthLastYear": "Той самий місяць минулого року",
  "calendar.selectADate": "Виберіть дату",
  "calendar.selectAggregation": "Виберіть відображуване значення",
  "calendar.selectAMonth": "Виберіть місяць",
  "calendar.selectAYear": "Виберіть рік",
  "calendar.selectGranularity": "Виберіть ступінь деталізації",
  "calendar.selectPeriod": "Виберіть період",
  "calendar.september": "Вересень",
  "calendar.sixHours": "6 годин",
  "calendar.start": "Початок",
  "calendar.startTime": "Час початку",
  "calendar.thirtyMinutes": "30 хв",
  "calendar.threeHours": "3 години",
  "calendar.timezone": "Часовий пояс",
  "calendar.today": "Сьогодні",
  "calendar.untilChanged": "До зміни",
  "calendar.untilTime": "До {time}",
  "calendar.untilTodayAt": "Сьогодні до {time}",
  "calendar.untilTomorrowAt": "Завтра до {time}",
  "calendar.use24HourFormat": "Використовувати 24-годинний формат",
  "calendar.week": "Тиждень",
  "calendar.year": "Рік",
  "calendar.yearToDate": "З початку року",
  "calendar.yesterday": "Вчора",
  "charts.averageOverThePeriod": "Середнє за період",
  "charts.calendarView": "Перегляд календаря",
  "charts.charts": "Діаграми",
  "charts.chartView": "Перегляд діаграми",
  "charts.comparison": "Порівняння",
  "charts.customizeComparisonMetrics": "Налаштування показників",
  "charts.customizeComparisonMetricsDescription": "Перетягніть елементи, щоб переупорядкувати метрики порівняння. Торкніться значка ока, щоб показати або сховати показники.",
  "charts.maxOverThePeriod": "Максимум за період",
  "charts.measureToDisplay": "Показник для відображення",
  "charts.minMaxRange": "Мін. / Макс.",
  "charts.noDataForThisPeriod": "Немає даних за цей період",
  "charts.observations": "Спостереження",
  "charts.observedTemperature": "Виміряна температура",
  "charts.showComparison": "Показати порівняння",
  "charts.stationComparison": "Порівняння станцій",
  "charts.stationComparisonDescription": "Порівняйте історичні дані погоди з іншою станцією",
  "charts.sumOverThePeriod": "Накопичено за період",
  "charts.viewAsList": "Список",
  "charts.viewAsPeriods": "Періоди",
  "common.add": "Додати",
  "common.altitude": "Висота",
  "common.analysis": "Аналіз",
  "common.average": "Середнє",
  "common.back": "Назад",
  "common.backToHome": "Повернутися на головну",
  "common.cancel": "Скасувати",
  "common.cannotBeEmpty": "Це поле не може бути порожнім.",
  "common.close": "Закрити",
  "common.dailyForecast": "Щоденний прогноз",
  "common.default": "За замовчуванням",
  "common.delete": "Видалити",
  "common.details": "Подробиці",
  "common.edit": "Редагувати",
  "common.exitFullscreen": "Вийти з повноекранного режиму",
  "common.forecast": "Прогноз",
  "common.frequency": "Частота",
  "common.full": "Повний",
  "common.fullscreen": "Повноекранний режим",
  "common.help": "Довідка",
  "common.hidden": "Приховані",
  "common.high": "Високий",
  "common.iDontKnowYet": "Я ще не знаю",
  "common.indoor": "У приміщенні",
  "common.labelValue": "{label}: {value}",
  "common.lastUpdate": "Останнє оновлення",
  "common.low": "Низький",
  "common.maximum": "Максимум",
  "common.medium": "Середній",
  "common.minimum": "Мінімум",
  "common.more": "Більше",
  "common.moreInformation": "Більше інформації",
  "common.next": "Далі",
  "common.no": "Ні",
  "common.noAccountNeeded": "Обліковий запис не потрібен",
  "common.noItemsAvailable": "Немає доступних елементів",
  "common.notNow": "Не зараз",
  "common.now": "Зараз",
  "common.numberOfActiveWarnings": "{warning_count, plural, one {# активне попередження про погоду} few {# активні попередження про погоду} many {# активних попереджень про погоду} other {# активного попередження про погоду}}",
  "common.openSettings": "Відкрити налаштування",
  "common.outdoor": "Надворі",
  "common.pageNotFound": "Сторінку не знайдено",
  "common.pageNotFoundDescription": "Сторінка, яку ви шукаєте, не існує або була переміщена.",
  "common.rain": "Дощ",
  "common.share": "Поділіться",
  "common.shareImageFailed": "Не вдалося поділитися зображенням",
  "common.shareYourWeather": "Поділіться своєю погодою",
  "common.skip": "Пропустити",
  "common.start": "Почати",
  "common.unknown": "Невідомий",
  "common.validate": "Підтвердити",
  "common.validEmail": "Потрібна дійсна адреса електронної пошти.",
  "common.very_low": "Дуже низький",
  "common.weatherObservations": "Спостереження за погодою",
  "common.welcome": "Ласкаво просимо до SmartMixin!",
  "common.wind": "Вітер",
  "common.yes": "Так",
  "common.zoomImage": "Збільшити зображення",
  "compass.E": "Сх",
  "compass.E_long": "Схід",
  "compass.ENE": "СхПнСх",
  "compass.ENE_long": "Схід-північний схід",
  "compass.ESE": "СхПдСх",
  "compass.ESE_long": "Схід-південний схід",
  "compass.N": "Пн",
  "compass.N_long": "Північ",
  "compass.NE": "ПнСх",
  "compass.NE_long": "Північний схід",
  "compass.NNE": "ПнПнСх",
  "compass.NNE_long": "Північ-північний схід",
  "compass.NNW": "ПнПнЗх",
  "compass.NNW_long": "Північ-північний захід",
  "compass.NW": "ПнЗх",
  "compass.NW_long": "Північний захід",
  "compass.S": "Пд",
  "compass.S_long": "Південь",
  "compass.SE": "ПдСх",
  "compass.SE_long": "Південний схід",
  "compass.SSE": "ПдПдСх",
  "compass.SSE_long": "Південь-південний схід",
  "compass.SSW": "ПдПдЗх",
  "compass.SSW_long": "Південь-південний захід",
  "compass.SW": "ПдЗх",
  "compass.SW_long": "Південний захід",
  "compass.W": "Зх",
  "compass.W_long": "Захід",
  "compass.WNW": "ЗхПнЗх",
  "compass.WNW_long": "Захід-північний захід",
  "compass.WSW": "ЗхПдЗх",
  "compass.WSW_long": "Захід-південний захід",
  "dashboard.currentObservations": "Поточні спостереження",
  "dashboard.currentRainEvent": "Поточний дощ",
  "dashboard.currentWeatherConditions": "Поточна погода",
  "dashboard.customizeDashboard": "Налаштувати",
  "dashboard.customizeDashboardDescription": "Перетягніть елементи, щоб змінити порядок на панелі. Натисніть на іконку ока, щоб показати або приховати розділи.",
  "dashboard.dashboard": "Панель приладів",
  "dashboard.dayRangeExpected": "{value} очікується о {time}",
  "dashboard.dayRangeReached": "{value} о {time}",
  "dashboard.dayRangeSteady": "Стабільно {value} увесь день",
  "dashboard.hiddenSensors": "Приховані датчики",
  "dashboard.lastRainEvent": "Останній дощ",
  "dashboard.manageSensors": "Керування датчиками",
  "dashboard.manageSensorsDescription": "Перетягніть елементи для зміни порядку датчиків. Натисніть на іконку ока, щоб показати або приховати датчики. Натисніть на назву, щоб перейменувати.",
  "dashboard.pressureSummary": "Підсумок тиску",
  "dashboard.rainEvents": "Дощові події",
  "dashboard.rainSummary": "Зведення дощу",
  "dashboard.shareOutdoorMeasures": "Поділіться своїми вимірюваннями надворі",
  "dashboard.shareOutdoorMeasuresDescription": "Долучайтеся до спільноти SmartMixin, зробивши свої вимірювання надворі видимими для інших. Вимірювання в приміщенні ніколи не передаються.",
  "dashboard.temperatureSummary": "Зведення по температурі",
  "dashboard.windSummary": "Зведення по вітру",
  "devices.batteryLevel": "Рівень заряду батареї",
  "devices.firmwareVersion": "Версія прошивки",
  "devices.moduleCount": "{count, plural, one {# модуль} few {# модулі} many {# модулів} other {# модуля}}",
  "devices.moduleType": "Тип модуля",
  "devices.noNetatmoWeatherStationYet": "У вас ще немає метеостанції Netatmo.",
  "devices.noOutdoorModule": "Функціонального зовнішнього модуля для цієї станції немає.",
  "devices.notReachable": "Немає зв'язку",
  "devices.serialNumber": "Серійний номер",
  "devices.signalAverage": "Середній",
  "devices.signalBad": "Слабкий",
  "devices.signalGood": "Добрий",
  "devices.signalStrength": "Сила сигналу",
  "devices.signalUnknown": "Невідомий",
  "devices.visitNetatmoWebsite": "Відвідайте сайт Netatmo",
  "devices.wifiStrength": "Сила сигналу Wi-Fi",
  "forecastMaps.addColor": "Додати колір",
  "forecastMaps.addLayer": "Додати шар",
  "forecastMaps.autoPreview": "Авто",
  "forecastMaps.backToMaps": "Назад до карт",
  "forecastMaps.build": "Згенерувати",
  "forecastMaps.buildCompleted": "Генерацію завершено",
  "forecastMaps.builderMetaDescription": "Створюйте власні прогнозні карти з шарів метеорологічних моделей.",
  "forecastMaps.builderTitle": "Конструктор карт",
  "forecastMaps.buildFailed": "Не вдалося згенерувати. Спробуйте ще раз.",
  "forecastMaps.buildNotPossible": "Цю карту поки не можна згенерувати — немає доступних прогнозних даних.",
  "forecastMaps.buildProgress": "Промальовування… {completed}/{total} кроків",
  "forecastMaps.buildStarting": "Запуск генерації…",
  "forecastMaps.byModel": "За моделлю",
  "forecastMaps.byZone": "За зоною",
  "forecastMaps.colormap": "Кольорова шкала",
  "forecastMaps.colormapCustom": "Власні кольори",
  "forecastMaps.colormapGroupDomain": "Метеорологічні шаблони",
  "forecastMaps.colormapGroupMatplotlib": "Наукові шаблони",
  "forecastMaps.colorScale": "Колірна шкала",
  "forecastMaps.contourLevels": "Рівні ізоліній",
  "forecastMaps.countryCanada": "Канада",
  "forecastMaps.countryFrance": "Франція",
  "forecastMaps.countryGermany": "Німеччина",
  "forecastMaps.countryItaly": "Італія",
  "forecastMaps.countryScandinavia": "Скандинавія",
  "forecastMaps.countrySpain": "Іспанія",
  "forecastMaps.countrySwitzerland": "Швейцарія",
  "forecastMaps.countryUnitedStates": "Сполучені Штати",
  "forecastMaps.customColormapMinColors": "Власна кольорова шкала потребує щонайменше двох кольорів",
  "forecastMaps.customExtent": "Власне охоплення",
  "forecastMaps.displayName": "Відображувана назва",
  "forecastMaps.downscaling": "Коефіцієнт проріджування прапорців вітру",
  "forecastMaps.dpi": "DPI",
  "forecastMaps.drawArea": "Намалювати область",
  "forecastMaps.east": "Схід",
  "forecastMaps.extentDrawHint": "Проведіть по карті, щоб намалювати область",
  "forecastMaps.extentInvalid": "Захід має бути меншим за схід, а південь — меншим за північ",
  "forecastMaps.height": "Висота (дюйми)",
  "forecastMaps.hourOffset": "+{hour} год",
  "forecastMaps.invalidHexColor": "Недійсний колір — використовуйте #RRGGBB",
  "forecastMaps.layers": "Шари",
  "forecastMaps.layerTypeBarbs": "Прапорці вітру",
  "forecastMaps.layerTypeContour": "Ізолінії",
  "forecastMaps.layerTypeFilledContour": "Залиті ізолінії",
  "forecastMaps.layerTypeMagnitude": "Модуль",
  "forecastMaps.layerTypeRaster": "Растр",
  "forecastMaps.layerTypeVectorField": "Векторне поле",
  "forecastMaps.leave": "Вийти",
  "forecastMaps.levelsCount": "Кількість",
  "forecastMaps.levelsInvalid": "Недійсні рівні ізоліній",
  "forecastMaps.levelsModeArange": "Фіксований крок",
  "forecastMaps.levelsModeExplicit": "Явні значення",
  "forecastMaps.levelsModeLinspace": "Рівномірно розподілені (кількість)",
  "forecastMaps.levelsStep": "Крок",
  "forecastMaps.levelsValues": "Значення",
  "forecastMaps.levelsValuesHint": "Через кому, за зростанням",
  "forecastMaps.localTimeHint": "Показано за вашим місцевим часом",
  "forecastMaps.mapDescription": "Опис",
  "forecastMaps.mapName": "Назва карти",
  "forecastMaps.mapNameRequired": "Введіть назву",
  "forecastMaps.mapSettings": "Налаштування карти",
  "forecastMaps.mapView": "Інтерактивна карта",
  "forecastMaps.maxLayersReached": "Ця карта досягла максимуму в {max} шарів.",
  "forecastMaps.maxValue": "Максимальне значення",
  "forecastMaps.memoryBudgetExceeded": "Роздільність перевищує бюджет промальовування — зменште DPI або висоту",
  "forecastMaps.memoryBudgetUsage": "Бюджет промальовування: {percent}%",
  "forecastMaps.metaDescription": "Анімовані прогнозні карти, побудовані за розрахунками моделей погоди.",
  "forecastMaps.metric": "Величина",
  "forecastMaps.metricRequired": "Виберіть величину",
  "forecastMaps.metricUnavailable": "Недоступно для цієї моделі",
  "forecastMaps.minBelowMax": "Мінімум має бути меншим за максимум",
  "forecastMaps.minMaxRequired": "Мінімальне та максимальне значення обов'язкові для цього типу шару",
  "forecastMaps.minValue": "Мінімальне значення",
  "forecastMaps.modelNoRun": "Поки немає завершеного прогону",
  "forecastMaps.moveLayerDown": "Перемістити вниз",
  "forecastMaps.moveLayerUp": "Перемістити вгору",
  "forecastMaps.myMaps": "Мої карти",
  "forecastMaps.nanClipToMin": "Обмежити мінімумом",
  "forecastMaps.nanMask": "Маскувати",
  "forecastMaps.nanPolicy": "Відсутні дані",
  "forecastMaps.nanSkip": "Пропустити",
  "forecastMaps.noCompletedRun": "Цю карту ще не побудовано. Завітайте пізніше.",
  "forecastMaps.noLayers": "Шарів поки немає. Додайте шар, щоб почати.",
  "forecastMaps.noMapsAvailable": "Прогнозні карти поки недоступні.",
  "forecastMaps.north": "Північ",
  "forecastMaps.opacity": "Непрозорість",
  "forecastMaps.overlayLegend": "Легенда",
  "forecastMaps.pause": "Пауза",
  "forecastMaps.play": "Відтворити",
  "forecastMaps.pointValueError": "Не вдалося завантажити прогноз для цієї точки.",
  "forecastMaps.pointValueLoading": "Завантаження прогнозу…",
  "forecastMaps.pointValueUnavailable": "Немає даних для цього часу.",
  "forecastMaps.presets": "Шаблони",
  "forecastMaps.preview": "Попередній перегляд",
  "forecastMaps.previewEmptyHint": "Налаштуйте принаймні один коректний шар, щоб промалювати попередній перегляд.",
  "forecastMaps.previewFailed": "Попередній перегляд не вдався",
  "forecastMaps.previewHour": "Година прогнозу",
  "forecastMaps.previewRendering": "Промальовування попереднього перегляду…",
  "forecastMaps.projection": "Проєкція",
  "forecastMaps.projectionLambertConformal": "Конформна Ламберта",
  "forecastMaps.projectionMercator": "Меркатора",
  "forecastMaps.projectionPlateCarree": "Plate carrée",
  "forecastMaps.projectionStereographic": "Стереографічна",
  "forecastMaps.regionEurope": "Європа",
  "forecastMaps.regionNorthAmerica": "Північна Америка",
  "forecastMaps.removeColor": "Видалити колір",
  "forecastMaps.removeLayer": "Видалити шар",
  "forecastMaps.retry": "Повторити",
  "forecastMaps.run": "Розрахунок: {run}",
  "forecastMaps.save": "Зберегти",
  "forecastMaps.selectExtentOnMap": "Вибрати область на карті",
  "forecastMaps.south": "Південь",
  "forecastMaps.title": "Прогнозні карти",
  "forecastMaps.uMetric": "U-компонента",
  "forecastMaps.unitConversion": "Перетворення одиниць",
  "forecastMaps.unitNone": "Немає",
  "forecastMaps.unsavedChangesBody": "У вас є незбережені зміни. Вийти та відхилити їх?",
  "forecastMaps.unsavedChangesTitle": "Незбережені зміни",
  "forecastMaps.useCurrentView": "Використати поточний вигляд",
  "forecastMaps.useModelDomain": "Вимк.: використовується вся область моделі",
  "forecastMaps.utcTime": "UTC: {time}",
  "forecastMaps.uvMetricsDiffer": "Величини U та V мають різнитися",
  "forecastMaps.valueBetween": "Має бути між {min} та {max}",
  "forecastMaps.variable": "Змінна",
  "forecastMaps.viewMap": "Переглянути карту",
  "forecastMaps.vMetric": "V-компонента",
  "forecastMaps.west": "Захід",
  "forecastMaps.windAnimation": "Анімація вітру",
  "forecastModels.addForecastModel": "Додати модель",
  "forecastModels.atYourStations": "Доступні на ваших станціях",
  "forecastModels.coverageLoading": "Визначаємо, які з ваших станцій покриває кожна модель…",
  "forecastModels.description_AROME": "Високороздільна модель Météo France із розв'язанням конвекції над Західною Європою з роздільністю 1,3 км. Найкраща у своєму класі для короткострокових прогнозів у Франції; оновлюється кожні три години.",
  "forecastModels.description_ARPEGE_EU": "Європейський вкладений домен моделі ARPEGE Météo France з роздільністю 10 км. Середньострокові прогнози над Європою, оновлюються чотири рази на день.",
  "forecastModels.description_ARPEGE_GLOBAL": "Глобальна чисельна модель погоди Météo France з роздільністю 25 км, працює до приблизно 4 днів. Оновлюється чотири рази на день.",
  "forecastModels.description_DMI_DINI": "HARMONIE DINI від DMI: модель із розв'язанням конвекції над північно-західною Європою — Данія, Бенілюкс, Ірландія, Велика Британія та Скандинавія — з роздільністю 2 км, що працює до 60 годин, оновлюється вісім разів на день. Містить змінені відкриті дані DMI (CC BY 4.0).",
  "forecastModels.description_EC_GDPS": "Глобальна детерміністична система прогнозування Environment Canada: всесвітня середньострокова модель з роздільністю 15 км, що працює до 10 днів, оновлюється двічі на день.",
  "forecastModels.description_EC_HRDPS": "Детерміністична система прогнозування високої роздільності Environment Canada: модель із розв'язанням конвекції над Канадою та північною частиною США з роздільністю 2,5 км, що працює до 48 годин, оновлюється чотири рази на день.",
  "forecastModels.description_EC_RDPS": "Регіональна детерміністична система прогнозування Environment Canada: середньострокова модель над Північною Америкою з роздільністю 10 км, оновлюється чотири рази на день.",
  "forecastModels.description_ECMWF_HRES": "Флагманська модель високої роздільної здатності (IFS) Європейського центру середньострокових прогнозів погоди, яку широко вважають провідною глобальною прогнозною системою у світі. Покриває всю планету з роздільною здатністю 25 км на строк до 15 днів, оновлюється чотири рази на добу. Містить змінені відкриті дані ECMWF (CC BY 4.0).",
  "forecastModels.description_GFS": "Флагманська середньострокова глобальна модель NOAA. Охоплює всю планету з роздільністю 25 км до 16 днів, оновлюється чотири рази на день.",
  "forecastModels.description_HRRR_CONUS": "High-Resolution Rapid Refresh від NOAA: модель із розв'язанням конвекції над континентальною частиною США з роздільністю 3 км, оновлюється щогодини. Найкраще підходить для дуже короткострокових прогнозів гроз і сильної погоди.",
  "forecastModels.description_ICON": "Глобальна модель ICON від DWD з роздільною здатністю 13 км, що охоплює всю планету до 7,5 днів, оновлюється чотири рази на день. Datenbasis: Deutscher Wetterdienst.",
  "forecastModels.description_ICON_2I": "ICON-2I від ItaliaMeteo, що працює спільно з ARPAE: модель із розв'язанням конвекції над Італією з роздільністю 2,2 км, що працює до 72 годин, оновлюється двічі на день. Містить відкриті дані ItaliaMeteo (CC BY 4.0).",
  "forecastModels.description_ICON_CH1": "Контрольний прогін ICON-CH1-EPS від MeteoSwiss: модель із розв'язанням конвекції над Альпами з роздільністю 1 км, що працює до 33 годин, оновлюється кожні три години.",
  "forecastModels.description_ICON_CH2": "Контрольний прогін ICON-CH2-EPS від MeteoSwiss: модель із розв'язанням конвекції над Альпами — Швейцарія та прилеглий альпійський регіон — з роздільністю 2,1 км, що працює до 120 годин, оновлюється чотири рази на день.",
  "forecastModels.description_ICON_DE": "Високороздільна модель DWD із розв'язанням конвекції над Німеччиною та сусідніми країнами з роздільністю 2,2 км. Короткострокові прогнози оновлюються двічі на день. Datenbasis: Deutscher Wetterdienst.",
  "forecastModels.description_ICON_EU": "Європейський вкладений домен моделі ICON DWD з роздільністю 7 км, що охоплює Європу та Північну Атлантику. Середньострокові прогнози оновлюються чотири рази на день. Datenbasis: Deutscher Wetterdienst.",
  "forecastModels.description_MET_NORWAY": "Відкрита служба прогнозу погоди Норвезького метеорологічного інституту, яка поєднує високороздільні скандинавські моделі з даними ECMWF для надання глобальних прогнозів на термін до 10 днів.",
  "forecastModels.description_MF_AROME_ANTILLES": "Вкладений домен AROME над французькими Антильськими островами (Гваделупа, Мартиніка) з роздільністю 2,5 км. Короткострокові прогнози оновлюються чотири рази на день.",
  "forecastModels.description_MF_AROME_GUYANE": "Вкладений домен AROME над Французькою Гвіаною з роздільністю 2,5 км. Короткострокові прогнози оновлюються чотири рази на день.",
  "forecastModels.description_MF_AROME_NOUVELLE_CALEDONIE": "Вкладений домен AROME над Новою Каледонією з роздільністю 2,5 км. Короткострокові прогнози оновлюються чотири рази на день.",
  "forecastModels.description_MF_AROME_POLYNESIE": "Вкладений домен AROME над Французькою Полінезією з роздільністю 2,5 км. Короткострокові прогнози оновлюються чотири рази на день.",
  "forecastModels.description_MF_AROME_REUNION_MAYOTTE": "Вкладений домен AROME над Реюньйоном та Майотою з роздільністю 2,5 км. Короткострокові прогнози оновлюються чотири рази на день.",
  "forecastModels.description_RRFS_CONUS": "Система Rapid Refresh Forecast NOAA над континентальними США з роздільною здатністю 3 км. Погодинні прогнози оновлюються вісім разів на добу: до 84 годин у чотирьох основних прогонах і до 18 годин в інших.",
  "forecastModels.description_RRFS_NORTH_AMERICA": "Система Rapid Refresh Forecast NOAA, що охоплює всю Північну Америку з роздільною здатністю 13 км. Погодинні прогнози до 84 годин, оновлюються чотири рази на добу.",
  "forecastModels.description_SMARTMIXIN_MULTIMODEL": "Флагманський прогноз SmartMixin. Для кожної години у вашому місцезнаходженні ми вибираємо найкращу доступну модель — зазвичай високороздільну регіональну модель там, де така існує (AROME у Франції, ICON-D2 у Німеччині, HRRR у США, ARPEGE Europe по всьому континенту…) і повертаємось до глобальної моделі в інших місцях — потім заповнюємо будь-які прогалини з сусідніх джерел. Результат — єдиний безшовний прогноз, що охоплює будь-яке місце у світі на термін до 14 днів, автоматично оновлюється щоразу, коли оновлюється будь-яка з базових моделей.",
  "forecastModels.description_WEATHERFLOW_FORECAST": "Власний глобальний прогноз Weatherflow, що поєднує кілька чисельних моделей погоди зі спостереженнями з його мережі метеостанцій Tempest. 10-денний глобальний горизонт.",
  "forecastModels.everywhereElse": "Скрізь інде",
  "forecastModels.everywhereElseFoot": "Використовується на кожній станції, до якої не дістають ваші бажані моделі.",
  "forecastModels.everywhereElsePick": "Виберіть одну",
  "forecastModels.fallbackBlend": "Суміш SmartMixin",
  "forecastModels.fallbackBlendSub": "Поєднує кілька моделей, кожну там, де вона найсильніша.",
  "forecastModels.fallbackEcmwf": "ECMWF",
  "forecastModels.fallbackEcmwfSub": "ECMWF HRES скрізь, куди він дістає.",
  "forecastModels.fallbackGfs": "GFS",
  "forecastModels.fallbackGfsSub": "Глобальна модель NOAA. Те, що сьогодні використовують усі облікові записи.",
  "forecastModels.fallbackResolution": "Найвища роздільність",
  "forecastModels.fallbackResolutionSub": "Найдрібніша сітка, доступна на кожній станції.",
  "forecastModels.forecastChipLabelWithRun": "{model}, розрахунок {run}",
  "forecastModels.forecastChipRunHint": "Натисніть і утримуйте, щоб показати або приховати останній розрахунок",
  "forecastModels.forecastComparisonDescription": "Легко порівнюйте результати моделей прогнозу з кількох джерел",
  "forecastModels.forecastFollowingPreferences": "За вашими налаштуваннями",
  "forecastModels.forecastModel": "Прогнозна модель",
  "forecastModels.forecastModelComparison": "Порівняння моделей прогнозу",
  "forecastModels.forecastModelCoverage": "Охоплення",
  "forecastModels.forecastModelDescription": "Опис",
  "forecastModels.forecastModels": "Моделі прогнозу",
  "forecastModels.forecastModelScopeGlobal": "Глобальна",
  "forecastModels.forecastModelScopeGlobalDescription": "Ця модель охоплює всю планету.",
  "forecastModels.forecastModelScopeRegional": "Регіональна",
  "forecastModels.forecastModelScopeRegionalDescription": "Ця модель охоплює лише певний регіон.",
  "forecastModels.forecastModelSpecifications": "Характеристики",
  "forecastModels.forecastNoPinLocation": "Жодна бажана модель не дістає до цього розташування — вирішує «скрізь інде».",
  "forecastModels.forecastNoPinStation": "Жодна бажана модель не дістає до цієї станції — вирішує «скрізь інде».",
  "forecastModels.forecastNoPreferredModels": "Бажані моделі ще не задано.",
  "forecastModels.forecastOverrideElsewhere": "Ваші налаштування діють скрізь інде.",
  "forecastModels.forecastPickForLocation": "Або виберіть одну для цього розташування",
  "forecastModels.forecastPickForStation": "Або виберіть одну для цієї станції",
  "forecastModels.forecastPinWinsLocation": "{model} — перша бажана модель, що дістає до цього розташування.",
  "forecastModels.forecastPinWinsStation": "{model} — перша бажана модель, що дістає до цієї станції.",
  "forecastModels.forecastServedNowHere": "Зараз тут це {model}",
  "forecastModels.forecastSetForLocation": "Задано для цього розташування",
  "forecastModels.forecastSetForStation": "Задано для цієї станції",
  "forecastModels.forecastSettingsRowSub": "Бажані моделі та що діє скрізь інде",
  "forecastModels.forecastStopUsingHere": "Не використовувати тут",
  "forecastModels.forecastUseForLocation": "Використовувати {model} для цього розташування",
  "forecastModels.forecastUseForStation": "Використовувати {model} для цієї станції",
  "forecastModels.forecastUsePreferred": "Використовувати мої бажані моделі",
  "forecastModels.frequencyHourly": "Щогодини",
  "forecastModels.horizon": "Горизонт",
  "forecastModels.horizonValue": "до {value} год",
  "forecastModels.meshSize": "Розмір сітки",
  "forecastModels.pickerShowAll": "Показати весь каталог",
  "forecastModels.pickerUnreachable": "{count, plural, one {Ще # модель не дістає} few {Ще # моделі не дістають} many {Ще # моделей не дістають} other {Ще # моделей не дістають}} до жодної з ваших станцій",
  "forecastModels.pinInUse": "Використовується",
  "forecastModels.pinShadowed": "Ніколи не використовується — модель вище покриває всі ваші станції",
  "forecastModels.pinSlots": "{used} з {max} · виберіть модель",
  "forecastModels.pinSlotsFull": "{max, plural, =1 {Єдиний слот зайнятий. Видаліть його модель, щоб додати іншу.} one {Усі # слот зайняті. Видаліть один, щоб додати інший.} few {Усі # слоти зайняті. Видаліть один, щоб додати інший.} many {Усі # слотів зайняті. Видаліть один, щоб додати інший.} other {Усі # слота зайняті. Видаліть один, щоб додати інший.}}",
  "forecastModels.pinsUncoveredCount": "{used} з ваших {count, plural, one {# станції} few {# станцій} many {# станцій} other {# станцій}}: жодна бажана модель до {used, plural, =1 {неї} other {них}} не дістає — вирішує «скрізь інде».",
  "forecastModels.pinsUncoveredNamed": "{stations}: жодна бажана модель до {count, plural, one {неї} other {них}} не дістає — вирішує «скрізь інде».",
  "forecastModels.pinUnreachable": "Ніколи не використовується — не дістає до жодної з ваших станцій",
  "forecastModels.pinUsedAt": "Використовується на {stations}",
  "forecastModels.pinUsedAtAll": "{count, plural, =1 {Використовується на вашій станції} other {Використовується на всіх станціях (#)}}",
  "forecastModels.pinUsedAtSome": "Використовується на {used} з {count, plural, one {# станції} few {# станцій} many {# станцій} other {# станцій}}",
  "forecastModels.preferredModels": "Бажані моделі",
  "forecastModels.preferredModelsAll": "Один список, усі станції",
  "forecastModels.preferredModelsOne": "Один список, діє скрізь",
  "forecastModels.publisher": "Розробник",
  "forecastModels.removePreferredModel": "Прибрати {model} з бажаних моделей",
  "forecastModels.resetForecastPreference": "Скинути",
  "forecastModels.resetForecastPreferenceHint": "Видаляє бажані моделі та повертає налаштування SmartMixin за замовчуванням.",
  "forecastModels.servedNowMany": "Зараз: GFS {count, plural, =1 {на вашій станції} other {на всіх ваших станціях (#)}}.",
  "forecastModels.servedNowNone": "Зараз: GFS скрізь.",
  "forecastModels.title_SMARTMIXIN_MULTIMODEL": "SmartMixin мультимодель",
  "forecastModels.title_WEATHERFLOW_FORECAST": "Прогноз Weatherflow",
  "forecastModels.weatherForecastModels": "Моделі прогнозу погоди",
  "helpCenter.articleCount": "{count, plural, one {# стаття} few {# статті} many {# статей} other {# статей}}",
  "helpCenter.articleNotFound": "Статтю не знайдено",
  "helpCenter.articleNotFoundDescription": "Стаття, яку ви шукаєте, не існує.",
  "helpCenter.backToHelpCenter": "Повернутися до довідкового центру",
  "helpCenter.browseByCategory": "Переглянути за категорією",
  "helpCenter.categoryNotFound": "Категорію не знайдено",
  "helpCenter.categoryNotFoundDescription": "Ця категорія не існує або не містить статей.",
  "helpCenter.contactSupport": "Зв'язатися з підтримкою",
  "helpCenter.feedbackHelpsImprove": "Ваші відгуки допомагають нам покращувати довідкові статті.",
  "helpCenter.feedbackReasonNotAnswer": "Не відповідає на моє запитання",
  "helpCenter.feedbackReasonOutdated": "Інформація застаріла",
  "helpCenter.feedbackReasonUnclear": "Інструкції незрозумілі",
  "helpCenter.feedbackWhatWentWrong": "У чому була проблема?",
  "helpCenter.helpCategoryAccount": "Обліковий запис",
  "helpCenter.helpCategoryBilling": "Оплата",
  "helpCenter.helpCategoryForecast": "Прогнози",
  "helpCenter.helpCategoryGettingStarted": "Початок роботи",
  "helpCenter.helpCategoryProviders": "Постачальники",
  "helpCenter.helpCategoryStations": "Станції",
  "helpCenter.helpCategoryTroubleshooting": "Усунення неполадок",
  "helpCenter.helpCenter": "Довідковий центр",
  "helpCenter.landingDescription": "Знайдіть відповіді на поширені запитання та дізнайтеся, як отримати максимум від SmartMixin.",
  "helpCenter.linkToSection": "Посилання на цей розділ",
  "helpCenter.menuItemDescription": "Поширені запитання та інструкції",
  "helpCenter.minRead": "{minutes} хв читання",
  "helpCenter.onThisPage": "На цій сторінці",
  "helpCenter.platformMobileApp": "Мобільний застосунок",
  "helpCenter.platformMobileOnly": "Лише в мобільному застосунку",
  "helpCenter.platformWebApp": "Вебзастосунок",
  "helpCenter.platformWebOnly": "Лише у вебзастосунку",
  "helpCenter.popularArticles": "Популярні статті",
  "helpCenter.relatedArticles": "Пов'язані статті",
  "helpCenter.searchArticles": "Пошук статей...",
  "helpCenter.stillNeedHelp": "Досі потрібна допомога?",
  "helpCenter.stillNeedHelpDescription": "Якщо ця стаття не відповіла на ваше запитання, я з радістю допоможу вам особисто.",
  "helpCenter.supportEmailSubject": "Допомога SmartMixin",
  "helpCenter.supportEmailSubjectTopic": "Допомога SmartMixin — {topic}",
  "helpCenter.thankYouForFeedback": "Дякуємо за ваш відгук!",
  "helpCenter.wasArticleHelpful": "Чи була ця стаття корисною?",
  "intro.locationDescription": "Дозвольте доступ до місцезнаходження, щоб отримувати точні прогнози, адаптовані до вашої локації — ніяких більше загальних прогнозів.",
  "intro.locationTitle": "Прогнози, створені для вас",
  "intro.notificationDescription": "Увімкніть сповіщення, щоб отримувати своєчасні попередження про важливі для вас зміни погоди — дощ, сніг чи екстремальні умови саме тоді, коли це потрібно.",
  "intro.notificationsTitle": "Не пропускайте зміни погоди",
  "intro.readyDescription": "Насолоджуйтеся точними прогнозами, актуальними даними про погоду та інформацією зі станцій по всьому світу — в одному потужному застосунку.",
  "intro.readyTitle": "Усе готово!",
  "intro.welcomeDescription": "Отримуйте гіперлокальні прогнози від провідних метеоагентств — а також доступ до понад 40 000 метеостанцій по всьому світу, щоб бачити реальні умови, минулі та теперішні.",
  "intro.welcomeTitle": "Ваш прогноз погоди, переосмислений",
  "landing.alsoAvailableOn": "Також доступно на:",
  "landing.featureAlertsDescription": "Задавайте власні порогові значення для будь-якого показника. Отримуйте сповіщення, коли падає температура, починається дощ або посилюється вітер.",
  "landing.featureAlertsTitle": "Розумні сповіщення",
  "landing.featureAnalyticsDescription": "Інтерактивні графіки, аналіз трендів і детальна статистика. Заглибтеся в дані про температуру, вологість, тиск, дощ і вітер.",
  "landing.featureAnalyticsTitle": "Розширена аналітика",
  "landing.featureExportDescription": "Отримуйте всі свої погодні дані електронною поштою у вигляді таблиці Excel, готової до подальшого аналізу в Excel, Google Таблицях або ваших улюблених інструментах.",
  "landing.featureExportTitle": "Експортуйте свої дані",
  "landing.featureForecastDescription": "Доступ до {count, plural, one {#+ професійної прогнозної моделі} few {#+ професійних прогнозних моделей} many {#+ професійних прогнозних моделей} other {#+ професійної прогнозної моделі}}, зокрема ECMWF, GFS і регіональних. Порівнюйте їх пліч-о-пліч і робіть власні прогнози.",
  "landing.featureForecastTitle": "Порівнюйте прогнозні моделі",
  "landing.featureHistoryDescription": "Доступ до історичних даних з погодинною, денною та місячною шкалою. Експортуйте їх в Excel для досліджень або особистих архівів.",
  "landing.featureHistoryTitle": "Багата історія",
  "landing.featureMultiBrandDescription": "Підключайте Netatmo, Davis, Tempest, Ecowitt, Ambient Weather та інші. Більше не потрібно перемикатися між застосунками.",
  "landing.featureMultiBrandTitle": "Усі бренди в одному застосунку",
  "landing.featuresSubtitle": "SmartMixin дає вам інструменти, щоб аналізувати, порівнювати та розуміти свої погодні дані як професіонал.",
  "landing.featuresTitle": "Створено для любителів даних",
  "landing.finalCtaButton": "Створити безкоштовний акаунт",
  "landing.finalCtaSubtitle": "Приєднуйтесь до тисяч ентузіастів погоди, які довіряють SmartMixin.",
  "landing.finalCtaTitle": "Готові глибше зануритися у свої погодні дані?",
  "landing.heroCta": "Почати безкоштовно",
  "landing.heroDescription": "Глибока аналітика, гарні графіки та професійні прогнози — усі ваші метеостанції в одному потужному застосунку.",
  "landing.heroSecondaryCta": "Дослідити карту",
  "landing.heroTagline": "Для ентузіастів погоди",
  "landing.heroTitle": "Погляньте на свою погоду як ніколи раніше",
  "landing.pricingFeatureAdvancedMetrics": "Розширені метрики",
  "landing.pricingFeatureAlerts": "Власні сповіщення",
  "landing.pricingFeatureExport": "Експорт даних (Excel)",
  "landing.pricingFeatureForecastComparison": "Порівняння прогнозів",
  "landing.pricingFeatureForecasts": "Моделі прогнозу",
  "landing.pricingFeatureForecastsFreeTier": "1 модель",
  "landing.pricingFeatureForecastsPremiumTier": "{count, plural, one {#+ модель} few {#+ моделі} many {#+ моделей} other {#+ моделі}}",
  "landing.pricingFeatureReports": "Аналіз та звіти",
  "landing.pricingFeatureStationComparison": "Порівняння станцій",
  "landing.pricingFeatureWidgets": "Віджети головного екрана",
  "landing.pricingFeatureYearOverYear": "Аналіз рік до року",
  "landing.pricingFreeCta": "Почати",
  "landing.pricingFreePrice": "0 €",
  "landing.pricingMostPopular": "Найпопулярніший",
  "landing.pricingPremiumCta": "Почати",
  "landing.pricingPremiumDescription": "Від 1,99 €/місяць — підпишіться на сайті, в App Store або Google Play",
  "landing.pricingSubtitle": "Почніть безкоштовно, перейдіть на платну версію, коли знадобиться більше.",
  "landing.pricingTitle": "Прості, прозорі ціни",
  "landing.statBrands": "Підтримуваних брендів",
  "landing.statForecasts": "Моделей прогнозу",
  "landing.statStations": "Метеостанцій",
  "landing.supportedDevicesNote": "Плюс понад {count, number} публічних станцій із мережі Всесвітньої метеорологічної організації",
  "landing.supportedDevicesSubtitle": "Підключіть свою метеостанцію за лічені хвилини. Ми підтримуємо {count, plural, one {# провідний бренд} few {# провідні бренди} many {# провідних брендів} other {# провідного бренду}}, і їх стає дедалі більше.",
  "landing.supportedDevicesTitle": "Працює з вашою станцією",
  "metrics.absolutePressure": "Абсолютний тиск",
  "metrics.airDensity": "Щільність повітря",
  "metrics.airGap": "Повітряний зазор",
  "metrics.apparentTemperature": "Відчутна температура",
  "metrics.AQI": "AQI",
  "metrics.AQI_24H": "24h AQI",
  "metrics.avg": "Середнє",
  "metrics.avg_wind": "Середній вітер",
  "metrics.beaufort": "Бофорт",
  "metrics.blackGlobeTemperature": "Темп. чорної кулі",
  "metrics.boilerOn": "Котел ВКЛ",
  "metrics.boilerOnInHours": "Котел ВКЛ (години)",
  "metrics.co2": "CO2",
  "metrics.conductivity": "Провідність",
  "metrics.dailyPrecipitation": "Добові опади",
  "metrics.dailyRain": "Добові опади",
  "metrics.degreeDayShort": "DD",
  "metrics.depth": "Глибина",
  "metrics.depthSensors": "Датчики глибини",
  "metrics.dewPoint": "Точка роси",
  "metrics.distance": "Відстань",
  "metrics.downTrend": "вниз",
  "metrics.ET": "Евапотранспірація",
  "metrics.etToday": "Евапотранспірація сьогодні",
  "metrics.feelsLike": "Відчувається як",
  "metrics.feelsLikeWithFormula": "Відчувається як ({formula})",
  "metrics.frostPoint": "Точка інею",
  "metrics.gust": "Порив",
  "metrics.hail": "Град",
  "metrics.heatIndex": "Індекс тепла",
  "metrics.heatingDegreeDays": "Градусодні опалення",
  "metrics.heatingPower": "Теплова потужність",
  "metrics.humidex": "Гумідекс",
  "metrics.humidity": "Вологість",
  "metrics.lastLightningImpact": "Останній удар",
  "metrics.lastMeasure": "Останнє вимірювання",
  "metrics.leafSensors": "Датчики листя",
  "metrics.leafWetness": "Вологість листя",
  "metrics.lightningDistance": "Відстань",
  "metrics.lightningStrikeCount": "Кількість ударів блискавки",
  "metrics.lightningStrikeDistance": "Відстань удару блискавки",
  "metrics.max": "Макс.",
  "metrics.max_gust": "Макс. порив",
  "metrics.maxToday": "Макс. сьогодні",
  "metrics.min": "Мін.",
  "metrics.noise": "Шум",
  "metrics.normalizedHeatingCoefficient": "Нормований коефіцієнт нагрівання",
  "metrics.outdoorTemperature": "Зовнішня температура",
  "metrics.PM_1": "PM1",
  "metrics.PM_10": "PM10",
  "metrics.PM_2P5": "PM2,5",
  "metrics.precipitation": "Опади",
  "metrics.pressure": "Тиск",
  "metrics.rain": "Дощ",
  "metrics.rainDurationValue": "Тривалість дощу: {duration}",
  "metrics.rainfallMeasurement": "Вимірювання кількості опадів",
  "metrics.rainRate": "Інтенсивність дощу",
  "metrics.relativePressure": "Відносний тиск",
  "metrics.setPoint": "Уставка",
  "metrics.snow": "Сніг",
  "metrics.snowfall": "Снігопад",
  "metrics.soilMoisture": "Вологість",
  "metrics.soilSensors": "Датчики грунту",
  "metrics.soilWaterTension": "Натяг ґрунтової вологи",
  "metrics.solarEnergy": "Сонячна енергія",
  "metrics.solarRadiation": "Сонячна радіація",
  "metrics.speed": "Швидкість",
  "metrics.stableTrend": "стабільний",
  "metrics.sum": "Сума",
  "metrics.temperature": "Температура",
  "metrics.temperatureSensors": "Датчики температури та вологості",
  "metrics.temperatureShort": "Темп.",
  "metrics.thsw": "THSW",
  "metrics.thw": "THW",
  "metrics.upTrend": "вгору",
  "metrics.uv": "УФ",
  "metrics.visibility": "Видимість",
  "metrics.weatherCondition": "Умови погоди",
  "metrics.wetBulbGlobeTemperature": "Темп. вологої кулі",
  "metrics.wetBulbTemperature": "Температура по вологому термометру",
  "metrics.wind": "Вітер",
  "metrics.windChill": "Вітро-холодовий індекс",
  "metrics.windDirection": "Напрямок вітру",
  "metrics.windMeasurement": "Вимірювання вітру",
  "metrics.windRun": "Вітровий пробіг",
  "metrics.windRunDescription": "Вітровий пробіг — це загальна відстань, яку долає вітер за певний період часу",
  "metrics.windSpeed": "Швидкість вітру",
  "network.cancelError": "Запит скасовано",
  "network.connectionError": "Сервер недоступний",
  "network.networkError": "Мережа недоступна",
  "network.serverError": "Щось пішло не так...",
  "network.timeoutError": "Час очікування підключення",
  "network.unknownError": "Невідома помилка",
  "premium.alreadyPremium": "У вас вже є преміум-акаунт!",
  "premium.bestValue": "Найкраща пропозиція",
  "premium.billingDetailsAndroid": "Безкоштовний пробний період: плата не стягується, якщо ви скасуєте підписку щонайменше за 24 години до його закінчення. Далі підписка SmartMixin поновлюється автоматично, якщо ви не скасуєте її щонайменше за 24 години до кінця поточного періоду; скасувати її можна будь-коли в налаштуваннях облікового запису Google Play. Кожне поновлення оплачується за ціною, зазначеною на кнопці вище. Оплата стягується з вашого облікового запису Google Play під час підтвердження покупки та на початку кожного періоду поновлення.",
  "premium.billingDetailsIos": "Безкоштовний пробний період: плата не стягується, якщо ви скасуєте підписку щонайменше за 24 години до його закінчення. Далі підписка SmartMixin поновлюється автоматично, якщо ви не скасуєте її щонайменше за 24 години до кінця поточного періоду; скасувати її можна будь-коли в налаштуваннях облікового запису App Store. Кожне поновлення оплачується за ціною, зазначеною на кнопці вище. Оплата стягується з вашого облікового запису App Store під час підтвердження покупки та на початку кожного періоду поновлення.",
  "premium.freeBannerBody": "Безкоштовні облікові записи отримують GFS скрізь — ваші бажані моделі та «скрізь інде» почнуть працювати щойно ви оформите підписку.",
  "premium.freeBannerTitle": "Налаштування діють із Premium",
  "premium.freeSubscription": "Безкоштовна преміум-підписка",
  "premium.freeTrialForPeriod": "Безкоштовний пробний період: {period, plural, one {# день} few {# дні} many {# днів} other {# дня}}",
  "premium.getUnlimitedAccess": "Необмежений доступ до:",
  "premium.manageMySubscription": "Керувати моєю підпискою",
  "premium.notPurchasedYet": "Для цього облікового запису магазину не знайдено покупки SmartMixin Premium.",
  "premium.orChooseMonthly": "Або оберіть щомісячно:",
  "premium.premium": "SmartMixin Premium",
  "premium.premiumActive": "Активна",
  "premium.premiumAnnualTrialInfo": "Почніть з безкоштовного пробного періоду на {days, plural, one {# день} few {# дні} many {# днів} other {# дня}}",
  "premium.premiumCurrentPlan": "Поточний план",
  "premium.premiumDownloadApp": "Завантажте застосунок, щоб підписатися:",
  "premium.premiumEndsOn": "Закінчується {date}",
  "premium.premiumFeatureAlerts": "Погодні сповіщення",
  "premium.premiumFeatureAnalysis": "Розширений аналіз погоди",
  "premium.premiumFeatureCharts": "Порівняння графіків",
  "premium.premiumFeatureExport": "Експорт даних",
  "premium.premiumFeatureForecast": "Регіональні моделі прогнозів",
  "premium.premiumFeatureNotification": "Віджет рядка стану",
  "premium.premiumFeatureTitle": "Функція Premium",
  "premium.premiumFeatureWidgets": "Віджети головного екрана",
  "premium.premiumFreePlan": "Безкоштовний",
  "premium.premiumInactive": "Без підписки",
  "premium.premiumManageStoreSubscription": "Ви оформили підписку через {store}. Керувати нею або скасувати її можна там.",
  "premium.premiumManageWebSubscription": "Керуйте підпискою, оновіть спосіб оплати або скасуйте.",
  "premium.premiumPremiumPlan": "Premium",
  "premium.premiumRenewsOn": "Поновлюється {date}",
  "premium.premiumSubscribeAnnual": "Щорічно — 9,99 €/рік",
  "premium.premiumSubscribedOn": "Підписка через {platform}",
  "premium.premiumSubscribedOnWeb": "Підписку оформлено на сайті",
  "premium.premiumSubscribeMonthly": "Щомісячно — 1,99 €/місяць",
  "premium.premiumSubscribeOnWeb": "Підпишіться зараз, щоб розблокувати всі преміум-функції.",
  "premium.premiumSubscriptionSuccess": "Вашу підписку активовано! Насолоджуйтесь усіма преміум-функціями.",
  "premium.premiumSubscriptionSuccessTitle": "Ласкаво просимо до Premium!",
  "premium.premiumWebappNotice": "Оформити підписку на сайті зараз неможливо.",
  "premium.pricePerMonth": "{price}/місяць",
  "premium.pricePerYear": "{price}/рік",
  "premium.purchasedNetatmoPro": "Раніше ви придбали Netatmo Pro ({date}). Це дає вам доступ до набору преміум-функцій. Підпишіться на одну з наведених нижче пропозицій, якщо хочете мати доступ до всіх преміум-функцій.",
  "premium.purchaseFailed": "Не вдалося завершити покупку. Спробуйте ще раз.",
  "premium.restoreFailed": "Не вдалося відновити покупки. Спробуйте ще раз.",
  "premium.restorePurchase": "Відновити покупку",
  "premium.savingsPercent": "Економія {percent}%",
  "premium.seePremium": "Дізнатися про Premium",
  "premium.startFreeTrial": "Почати безкоштовну пробну версію",
  "premium.storeUnavailable": "Магазин зараз недоступний. Спробуйте пізніше.",
  "premium.subscribeNow": "Підписатися зараз — без пробного періоду",
  "premium.switchToPremium": "Перейдіть на SmartMixin Premium",
  "premium.thenPrice": "потім {price}",
  "providerHints.ambientWeatherApiKey": "Створено в налаштуваннях облікового запису на ambientweather.net.",
  "providerHints.davisApiSecret": "Показується лише один раз при створенні ключа V2 API — зберігайте у надійному місці.",
  "providerHints.davisV2ApiKey": "Зі сторінки ключів V2 API на weatherlink.com.",
  "providerHints.ecowittApi": "Зі сторінки API вашого облікового запису Ecowitt.",
  "providerHints.ecowittApp": "Ключ застосунку, також із вашого облікового запису Ecowitt.",
  "providerHints.myAcuriteCredentialsBanner": "Використовуйте email і пароль облікового запису My AcuRite — не вхід у SmartMixin.",
  "providerHints.myAcuriteEmail": "Електронна пошта вашого облікового запису My AcuRite — не ваш вхід у SmartMixin.",
  "providerHints.myAcuritePassword": "Пароль вашого облікового запису My AcuRite.",
  "providerHints.weatherflowToken": "Особистий токен із tempestwx.com → налаштування → авторизації даних.",
  "providerHints.wundergroundEditKey": "Використати інший ключ",
  "providerHints.wundergroundKey": "Довгий рядок зі сторінки API-ключів вашого облікового запису Weather Underground — не ваш пароль на wunderground.com.",
  "providerHints.wundergroundKeyExample": "напр. 5f6a7b8c9dabcdef…",
  "providerHints.wundergroundKeyVerified": "API-ключ підтверджено",
  "providerHints.wundergroundNoStationsNearby": "Поблизу цього місця не знайдено станцій. Спробуйте ввести ID станції безпосередньо.",
  "providerHints.wundergroundStationIdExample": "напр. KCASANFR123",
  "providerIntro.ambientWeatherStep2": "Отримайте свій API-ключ Ambient Weather.",
  "providerIntro.davisStep2": "Отримайте свій ключ V2 API і API-секрет Davis.",
  "providerIntro.ecowittStep2": "Отримайте свій API-ключ і ключ застосунку Ecowitt.",
  "providerIntro.getStarted": "Почати",
  "providerIntro.myAcuriteStep2": "Використовуйте email і пароль вашого наявного облікового запису My AcuRite.",
  "providerIntro.netatmoEnergyStep2": "Увійдіть у Netatmo за запитом — API-ключ не потрібен.",
  "providerIntro.netatmoWeatherStep2": "Увійдіть у Netatmo за запитом — API-ключ не потрібен.",
  "providerIntro.signupBanner": "Майже готово — створіть безкоштовний обліковий запис SmartMixin, щоб підключити {provider}.",
  "providerIntro.step1": "Увійдіть у свій обліковий запис SmartMixin (НЕ у {provider}).",
  "providerIntro.step3EmailPassword": "Введіть їх тут.",
  "providerIntro.step3KeyOrToken": "Вставте сюди.",
  "providerIntro.step3OAuth": "Авторизуйте SmartMixin у спливаючому вікні.",
  "providerIntro.step3Wunderground": "Вставте свій API-ключ, потім виберіть найближчу станцію або введіть будь-який ID станції.",
  "providerIntro.title": "Підключити {provider}",
  "providerIntro.weatherflowStep2": "Отримайте свій особистий токен Tempest.",
  "providerIntro.wundergroundBrowsePublic": "Не маєте станції? Перегляньте публічні",
  "providerIntro.wundergroundFindNearby": "Знайти станції поблизу",
  "providerIntro.wundergroundOrEnterId": "Або введіть ID станції",
  "providerIntro.wundergroundStep2": "Отримайте свій API-ключ Weather Underground. Потім ви зможете підключити будь-яку станцію — свою або публічну.",
  "reports.agroMeteorology": "Агрометеорологія",
  "reports.analysis": "Аналіз",
  "reports.annualCumulativeRainfallComparison": "Порівняння річної сумарної кількості опадів",
  "reports.annualHeatingDurationComparison": "Порівняння річної тривалості опалення",
  "reports.annualHeatingEfficiency": "Річна ефективність опалення",
  "reports.annualIndoorComparison": "Щорічне порівняння в приміщенні",
  "reports.annualOutdoorComparison": "Щорічне порівняння на відкритому повітрі",
  "reports.annualOutdoorReport": "Річний звіт про зовнішні вимірювання",
  "reports.annualReport": "Річний звіт",
  "reports.annualSolarReport": "Річний сонячний звіт",
  "reports.annualWaterBalance": "Річний водний баланс",
  "reports.annualWaterBalanceCarryOver": "Перенести з {year} року ({value})",
  "reports.annualWaterBalanceDescription": "Водний баланс (спрощена версія, використовуються лише дощ і сумарне випаровування) допомагає керувати водопостачанням",
  "reports.avgHumidity": "Середня вологість",
  "reports.avgMaxTemperature": "Середня T°макс",
  "reports.avgMetric": "Середнє – {metric}",
  "reports.avgMinTemperature": "Середня T°min",
  "reports.avgPressure": "Середній тиск",
  "reports.avgTemperature": "Середня температура",
  "reports.chartsAndTable": "Графіки й таблиця",
  "reports.climateNormalPeriodOfRecord": "Період спостережень ({years, plural, one {# рік} few {# роки} many {# років} other {# року}})",
  "reports.climateNormals": "Кліматичні норми",
  "reports.climateNormalStandardLabel": "Стандартна норма ({period})",
  "reports.climateTrendPerDecade": "Тренд температури: {value} за десятиліття (дані за {years, plural, one {# рік} few {# роки} many {# років} other {# року}})",
  "reports.coldestMonthRanking": "Найхолодніший {month} за історію спостережень",
  "reports.comfortable": "Комфортно (45% {lessThan} вологість ≤ 60%)",
  "reports.cumulativeRainfall": "Сумарні опади",
  "reports.cumulativeRainfallDescription": "Відстежуйте загальну кількість опадів, накопичених за обраний період.",
  "reports.dailyMaxRainfall": "Макс. добова кількість опадів",
  "reports.dataExport": "Експорт даних",
  "reports.dataExportXlsxFormatDescription": "Експортуйте всі дані вашої станції у формат Excel (*.xlsx). Після натискання кнопки через кілька хвилин ви отримаєте електронний лист із обробленими даними.",
  "reports.daysOfData": "{days, plural, one {# день} few {# дні} many {# днів} other {# дня}} даних",
  "reports.daysWithFrost": "Дні з морозом",
  "reports.daysWithHeavyRain": "Дні із сильним дощем (≥ {threshold})",
  "reports.daysWithoutThaw": "Дні без відлиги",
  "reports.daysWithStrongFrost": "Дні з сильними морозами",
  "reports.emailSent": "На вашу поштову скриньку надіслано електронний лист",
  "reports.frostDays": "Морозні дні",
  "reports.grasslandTemperatureSum": "Сума температур пасовища",
  "reports.grasslandTemperatureSumDescription": "Якщо сума {threshold} перевищена навесні, досягнуто стабільного початку вегетації (працює в Європі)",
  "reports.growingDegreeDays": "Градусо-дні росту",
  "reports.highPressure": "Антициклон (середній тиск ≥ 1013 мбар)",
  "reports.iceDays": "Дні без відлиги",
  "reports.indoorReport": "Звіт про приміщення",
  "reports.keyFacts": "Ключові факти",
  "reports.longestDrySpell": "Найдовший сухий період",
  "reports.longestRunOfRainyDays": "Найдовша серія дощових днів",
  "reports.longestRunWithoutRun": "Найдовший період без дощу",
  "reports.longestWetSpell": "Найдовший дощовий період",
  "reports.lowPressure": "Низький тиск (середній тиск {lessThan} 1013 мбар)",
  "reports.maxHumidity": "Максимальна вологість",
  "reports.maxMetric": "Максимум – {metric}",
  "reports.maxPressure": "Максимальний тиск",
  "reports.maxTemperature": "Максимальна температура",
  "reports.maxTempGreaterThan": "T°max ≥",
  "reports.maxTempMagnitude24h": "Максимальна амплітуда (/24 год)",
  "reports.minHumidity": "Мінімальна вологість",
  "reports.minMetric": "Мінімум – {metric}",
  "reports.minPressure": "Мінімальний тиск",
  "reports.minTemperature": "Мінімальна температура",
  "reports.minTempMagnitude24h": "Мінімальна амплітуда (/24 год)",
  "reports.monthlyAverageCountdown": "{days, plural, one {Ще # день} few {Ще # дні} many {Ще # днів} other {Ще # дня}} цього місяця",
  "reports.monthlyAverageCountdownDetail": "Тоді з’являться середнє за місяць і його рейтинг.",
  "reports.monthlyAverageRule": "Середні за місяць і рейтинги з’являться, коли в календарному місяці буде записано {days, plural, one {# день} few {# дні} many {# днів} other {# дня}}.",
  "reports.monthlyHeatingEfficiency": "Місячна ефективність опалення",
  "reports.monthlyOutdoorReport": "Щомісячний звіт про зовнішні вимірювання",
  "reports.monthlyReport": "Місячний звіт",
  "reports.monthlySolarReport": "Місячний сонячний звіт",
  "reports.monthlyWindReport": "Місячний звіт про вітер",
  "reports.monthsOfData": "{months, plural, one {# місяць} few {# місяці} many {# місяців} other {# місяця}} даних",
  "reports.numberOfDays": "Кількість днів",
  "reports.outdoorReport": "Звіт про зовнішні вимірювання",
  "reports.overviewSection": "Огляд",
  "reports.rainfall": "Опади",
  "reports.rainyDays": "Дощові дні",
  "reports.recordDailyRain": "Найдощовіший день",
  "reports.recordHigh": "Рекорд тепла",
  "reports.recordLow": "Рекорд холоду",
  "reports.recordsAndClimatology": "Рекорди та клімат",
  "reports.recordsSince": "Рекорди з {date}",
  "reports.recordWindGust": "Найсильніший порив вітру",
  "reports.relativelyWet": "Відносно вологий (60% {lessThan} вологість ≤ 80%)",
  "reports.sectionReportCount": "{count, plural, one {# звіт} few {# звіти} many {# звітів} other {# звітів}}",
  "reports.sendEmail": "Відправити лист",
  "reports.summerDays": "Літні дні",
  "reports.tooDry": "Занадто сухо (вологість ≤ 45%)",
  "reports.tooWet": "Занадто вологий (вологість {greaterThan} 80%)",
  "reports.tropicalNights": "Тропічні ночі",
  "reports.unlockPremiumSubtitle": "Входить у SmartMixin Premium",
  "reports.unlockPremiumTitle": "Розблокуйте {count, plural, one {# преміум-функцію} few {# преміум-функції} many {# преміум-функцій} other {# преміум-функцій}}",
  "reports.warmestMonthRanking": "Найтепліший {month} за історію спостережень",
  "reports.waterBalance": "Водний баланс",
  "reports.yearsOfData": "{years, plural, one {# рік} few {# роки} many {# років} other {# року}} даних",
  "reports.yearToDateTemperatureComparison": "Порівняння температури від початку року",
  "sensors.bgtSensors": "Чорна куля та WBGT",
  "sensors.cameraFeed": "Камера",
  "sensors.compareHumidity": "Порівняти вологість",
  "sensors.compareMoisture": "Порівняти вологість ґрунту",
  "sensors.comparePm25": "Порівняти PM2.5",
  "sensors.compareTemperatures": "Порівняти температури",
  "sensors.compareWaterTension": "Порівняти натяг ґрунтової вологи",
  "sensors.depthByChannel": "Глибина за каналом",
  "sensors.heatStressExtreme": "Екстремальний тепловий стрес",
  "sensors.heatStressModerate": "Помірний тепловий стрес",
  "sensors.heatStressNone": "Немає теплового стресу",
  "sensors.heatStressStrong": "Сильний тепловий стрес",
  "sensors.heatStressVeryStrong": "Дуже сильний тепловий стрес",
  "sensors.indoorClimate": "Мікроклімат",
  "sensors.indoorCo2Levels": "Рівні CO2",
  "sensors.indoorTemperatureAndHumidity": "Температура та вологість",
  "sensors.leafWetnessByChannel": "Вологість листя за каналом",
  "sensors.lightningSensor": "Блискавка",
  "sensors.moistureByChannel": "Вологість ґрунту за каналом",
  "sensors.noDataAvailable": "Дані відсутні",
  "sensors.pm10AndAqi": "PM10 & AQI",
  "sensors.pm1AndAqi": "PM1.0 & AQI",
  "sensors.pm25AndAqi": "PM2.5 & AQI",
  "sensors.pm25ByChannel": "PM2.5 за каналом",
  "sensors.pm4AndAqi": "PM4.0 & AQI",
  "sensors.selectChannel": "Оберіть канал",
  "sensors.sensorDetailDescription": "Перегляд історичних даних та тенденцій для каналів датчика.",
  "sensors.sensorHistory": "Історія датчика",
  "sensors.soilConductivityByChannel": "Провідність за каналом",
  "sensors.soilTemperatureByChannel": "Температура ґрунту за каналом",
  "sensors.strikesToday": "Удари сьогодні",
  "sensors.temperatureByChannel": "Температура за каналом",
  "sensors.viewChart": "Переглянути графік",
  "sensors.waterTensionByChannel": "Натяг ґрунтової вологи за каналом",
  "settings.appearance": "Зовнішній вигляд",
  "settings.appVersion": "SmartMixin v{version}",
  "settings.arabic": "арабська",
  "settings.bulgarian": "болгарська",
  "settings.catalan": "каталонська",
  "settings.chartGestures": "Жести на діаграмах",
  "settings.chartGesturesDescription": "Проведення пальцем по діаграмах змінює період часу, зведення діаграм змінює масштаб часу",
  "settings.choiceCount": "{count, plural, one {Доступна: #} few {Доступно: #} many {Доступно: #} other {Доступно: #}}",
  "settings.contactUs": "Зв'язатися з нами",
  "settings.contactUsDescription": "Отримайте допомогу або надішліть відгук",
  "settings.croatian": "хорватська",
  "settings.czech": "чеська",
  "settings.dailyDetailByPeriods": "Деталі дня за періодами",
  "settings.dailyDetailByPeriodsDescription": "Групувати 24 години на ніч, ранок, день і вечір — той самий поділ, що й у зведенні дня.",
  "settings.danish": "датська",
  "settings.dark": "Темна тема",
  "settings.dataDisplay": "Відображення даних",
  "settings.dateAndTime": "Дата і час",
  "settings.donateButton": "Зробити пожертву",
  "settings.donateDescription": "SmartMixin створює невелика команда. Якщо застосунок корисний для вас, ви можете підтримати його розвиток разовою пожертвою на будь-яку суму. Це подарунок — він не змінює ваш тариф і не відкриває жодних функцій.",
  "settings.donateSuccessBody": "Ваша пожертва допомагає SmartMixin працювати та ставати кращим. Ми щиро це цінуємо.",
  "settings.donateSuccessTitle": "Дякуємо за вашу підтримку!",
  "settings.donateTitle": "Підтримайте SmartMixin",
  "settings.dragToReorder": "Перетягніть, щоб змінити порядок",
  "settings.dutch": "голландська",
  "settings.english": "англійська",
  "settings.french": "французька",
  "settings.german": "німецька",
  "settings.gestures": "Жести",
  "settings.greek": "грецька",
  "settings.hungarian": "угорська",
  "settings.italian": "італійська",
  "settings.japanese": "японська",
  "settings.korean": "корейська",
  "settings.language": "Мова",
  "settings.languageDescription": "Бажана мова",
  "settings.light": "Світла тема",
  "settings.measurementUnits": "Одиниці вимірювання",
  "settings.netatmoDashboard": "Панель Netatmo",
  "settings.netatmoLayoutCards": "Список карток",
  "settings.netatmoLayoutCardsDescription": "По картці на модуль, усе одним списком",
  "settings.netatmoLayoutClassic": "Класичний",
  "settings.netatmoLayoutClassicDescription": "Дві картки, перемикання між модулями",
  "settings.netatmoNewLayoutNotice": "Новий вигляд панелі: по картці на модуль.",
  "settings.netatmoSwitchBackToClassic": "Повернути класичний",
  "settings.netatmoSwitchToLayout": "Перемкнути на {layout}",
  "settings.norwegian": "норвезька",
  "settings.notificationsSection": "Сповіщення",
  "settings.ongoingNotificationEnabled": "Увімкнути постійне сповіщення",
  "settings.ongoingNotificationMetrics": "Відображені показники",
  "settings.ongoingNotificationPermissionRequired": "Потрібен дозвіл на сповіщення",
  "settings.ongoingNotificationPreviewHint": "Попередній перегляд — увімкніть віджет, щоб показати його",
  "settings.ongoingNotificationStatusBar": "Рядок стану",
  "settings.polish": "польська",
  "settings.portuguese": "португальська",
  "settings.preferencesSection": "Параметри",
  "settings.privacyPolicy": "Політика конфіденційності",
  "settings.russian": "російська",
  "settings.serbian": "сербська",
  "settings.settings": "Налаштування",
  "settings.settingsPageTitle": "Налаштування - {page}",
  "settings.slovak": "словацька",
  "settings.smallDecimals": "Малі десяткові",
  "settings.smallDecimalsDescription": "Відображати десяткові цифри меншим розміром",
  "settings.spanish": "іспанська",
  "settings.statusBarWidget": "Віджет рядка стану",
  "settings.statusBarWidgetDescription": "Завжди видимі дані про погоду",
  "settings.subscriptionSection": "Підписка",
  "settings.supportSection": "Підтримка",
  "settings.swedish": "шведська",
  "settings.systemTheme": "Тема системи",
  "settings.termsOfService": "Умови використання",
  "settings.turkish": "турецька",
  "settings.ukrainian": "українська",
  "settings.units": "Одиниці",
  "settings.unitsDescription": "Одиниці вимірювання, що відображаються в додатку",
  "settings.update": "Оновити",
  "settings.windDirectionConvention": "Стрілка напрямку вітру",
  "settings.windDirectionConventionDescription": "Оберіть відображення стрілок напрямку вітру",
  "settings.windDirectionMeteorological": "Напрямок джерела",
  "settings.windDirectionMeteorologicalDescription": "Стрілка вказує, звідки дме вітер (метеорологічна конвенція)",
  "settings.windDirectionOceanographic": "Напрямок потоку",
  "settings.windDirectionOceanographicDescription": "Стрілка вказує, куди дме вітер (океанографічна конвенція)",
  "stations.addAStation": "Додайте станцію",
  "stations.addToFavorites": "Додати до вибраного",
  "stations.addYourOwnStation": "Додайте власну станцію",
  "stations.clearRecentLocations": "Очистити все",
  "stations.clearSearch": "Очистити пошук",
  "stations.currentLocation": "Поточне розташування",
  "stations.customizedStationName": "Індивідуальна назва станції",
  "stations.favoriteLocations": "Вибране",
  "stations.favoriteLocationsEmpty": "Ви можете додати до 5 улюблених місць.",
  "stations.favoriteStations": "Улюблені станції",
  "stations.filterStationDescription": "Не показуйте станції з ненадійними показниками",
  "stations.filterStations": "Фільтрувати станції",
  "stations.filterStationSourceDescription": "Виберіть постачальників станцій, які ви хочете відобразити на карті",
  "stations.findStationsNearYou": "Знайти станції поблизу",
  "stations.hiddenStations": "Приховані станції",
  "stations.hiddenStationsDescription": "Ви можете знову показати станцію, натиснувши піктограму ока поруч.",
  "stations.lastSeen": "востаннє {time}",
  "stations.location": "Місцезнаходження",
  "stations.locationAddedToFavorites": "Місцезнаходження додано до вибраного",
  "stations.locationNotGranted": "Дозвіл на розташування не надається. Будь ласка, дозвольте отримати доступ до свого місцезнаходження в налаштуваннях пристрою.",
  "stations.locationRemovedFromFavorites": "Місцезнаходження видалено з вибраного",
  "stations.locations": "Розташування",
  "stations.locationUnavailable": "Не вдалося визначити ваше місцезнаходження. Перевірте налаштування пристрою.",
  "stations.maxFavoriteLocationsReached": "Ви можете мати не більше 5 улюблених місць. Видаліть одне, щоб додати інше.",
  "stations.modifyFavoriteStations": "Змініть улюблені станції",
  "stations.modifyFavoriteStationsDescription": "Ви можете змінити порядок улюблених станцій, перетягуючи їх. Ви також можете видалити їх зі списку.",
  "stations.myLocation": "Моє місцезнаходження",
  "stations.nearbyWeatherStations": "Метеостанції поблизу",
  "stations.noLocationsFound": "Місця не знайдено",
  "stations.noSearchResults": "Немає статей, що відповідають вашому запиту",
  "stations.noStationsFound": "Станції не знайдено",
  "stations.noWeatherStationYet": "У вас ще немає метеостанції.",
  "stations.recentLocations": "Недавні",
  "stations.recentLocationsEmpty": "Ваша недавня історія порожня.",
  "stations.removeFromFavorites": "Видалити з вибраного",
  "stations.searchForLocation": "Пошук місця",
  "stations.searchForWeatherStation": "Пошук метеостанції",
  "stations.searchResults": "Результати пошуку",
  "stations.searchResultsEmpty": "Жодних результатів не знайдено.",
  "stations.searchResultsFound": "{count, plural, one {Знайдено # результат} few {Знайдено # результати} many {Знайдено # результатів} other {Знайдено # результату}}",
  "stations.searchStationsDescription": "Введіть місто, адресу або назву місця, щоб знайти метеостанції поблизу.",
  "stations.searchStationsHint": "Використовуйте рядок пошуку вище, щоб знайти метеостанції в будь-якій точці світу.",
  "stations.selectStationForComparison": "Виберіть станцію для порівняння",
  "stations.stationAddedToFavorites": "Станція додана до вибраного",
  "stations.stationCount": "{count, plural, one {# станція} few {# станції} many {# станцій} other {# станції}}",
  "stations.stationInformation": "Інформація про станцію",
  "stations.stationName": "Назва станції",
  "stations.stationObservationsDescription": "Показувати останні спостереження з метеостанцій",
  "stations.stationRemovedFromFavorites": "Станцію видалено з вибраного",
  "stations.stationsNear": "Станції поблизу: {place}",
  "stations.stationType": "Тип станції",
  "stations.statusOffline": "Поза мережею",
  "stations.statusOnline": "В мережі",
  "stations.statusStale": "Застаріле",
  "stations.tryAnotherLocation": "Ми не змогли знайти метеостанції поблизу цього місця. Спробуйте пошукати в іншому районі.",
  "stations.weatherStation": "Метеостанція",
  "stations.weatherStationCount": "{count, plural, one {# метеостанція} few {# метеостанції} many {# метеостанцій} other {# метеостанції}}",
  "stations.weatherStations": "Метеостанції",
  "stations.welcomeConnectService": "Маєте метеостанцію? Підключіть свій сервіс",
  "stations.welcomeSubtitle": "Ваша погода — все в одному місці",
  "thermostat.away": "Відсутність",
  "thermostat.boilerOn": "Котел ВКЛ",
  "thermostat.hg": "Захист від замерзання",
  "thermostat.homeInformation": "Інформація про дім",
  "thermostat.homeName": "Назва дому",
  "thermostat.manualBoost": "Ручне підвищення",
  "thermostat.manualSetpointUntil": "Ручне задане значення до",
  "thermostat.noThermostatYet": "У вас ще немає термостата.",
  "thermostat.relay": "Реле",
  "thermostat.room": "Кімната",
  "thermostat.rooms": "Кімнати",
  "thermostat.smartThermostat": "Розумний термостат",
  "thermostat.smartValve": "Розумний клапан",
  "thermostat.whenBackHome": "Коли ви повернетеся додому?",
  "units.celsius": "Цельсій",
  "units.fahrenheit": "Фаренгейт",
  "units.inch": "Дюйми",
  "units.inchOfMercury": "Дюйми ртутного стовпчика",
  "units.kelvin": "Кельвін",
  "units.kilometerPerHour": "Кілометри на годину",
  "units.knot": "Вузли",
  "units.meterPerSecond": "Метри в секунду",
  "units.milePerHour": "Милі на годину",
  "units.millibar": "Мілібари",
  "units.millimeter": "Міліметри",
  "units.millimeterOfMercury": "Міліметри ртутного стовпчика",
  "weatherConditions.blizzard": "Хуртовина",
  "weatherConditions.blowingDust": "Пилова поземка",
  "weatherConditions.blowingSnow": "Поземок",
  "weatherConditions.breezy": "Легкий вітер",
  "weatherConditions.clear": "Ясно",
  "weatherConditions.cloudy": "Хмарно",
  "weatherConditions.drizzle": "Мряка",
  "weatherConditions.flurries": "Слабкий сніг",
  "weatherConditions.foggy": "Туман",
  "weatherConditions.freezingDrizzle": "Переохолоджена мряка",
  "weatherConditions.freezingRain": "Крижаний дощ",
  "weatherConditions.frigid": "Сильний мороз",
  "weatherConditions.hail": "Град",
  "weatherConditions.haze": "Імла",
  "weatherConditions.heavyRain": "Сильний дощ",
  "weatherConditions.heavySnow": "Сильний снігопад",
  "weatherConditions.hot": "Спека",
  "weatherConditions.hurricane": "Ураган",
  "weatherConditions.isolatedThunderstorms": "Поодинокі грози",
  "weatherConditions.mixedRainAndHail": "Дощ з градом",
  "weatherConditions.mostlyClear": "Переважно ясно",
  "weatherConditions.mostlyCloudy": "Переважно хмарно",
  "weatherConditions.mostlySunny": "Переважно сонячно",
  "weatherConditions.notAvailable": "Погодні умови недоступні",
  "weatherConditions.partlyCloudy": "Мінлива хмарність",
  "weatherConditions.rain": "Дощ",
  "weatherConditions.rainSleet": "Дощ з крижаною крупою",
  "weatherConditions.rainSnow": "Дощ зі снігом",
  "weatherConditions.scatteredShowers": "Розсіяні зливи",
  "weatherConditions.scatteredSnowShowers": "Розсіяні снігові заряди",
  "weatherConditions.scatteredThunderstorms": "Розсіяні грози",
  "weatherConditions.showers": "Зливи",
  "weatherConditions.sleet": "Крижана крупа",
  "weatherConditions.smoke": "Дим",
  "weatherConditions.snow": "Сніг",
  "weatherConditions.snowShowers": "Снігові заряди",
  "weatherConditions.strongStorms": "Сильні грози",
  "weatherConditions.sunny": "Сонячно",
  "weatherConditions.thunderstorms": "Грози",
  "weatherConditions.tornado": "Торнадо",
  "weatherConditions.tropicalStorm": "Тропічний шторм",
  "weatherConditions.windy": "Вітряно",
  "weatherConditions.wintryMix": "Змішані зимові опади",
  "weatherMap.legendHeavy": "Сильний",
  "weatherMap.legendLight": "Слабкий",
  "weatherMap.legendLightningHelp": "Колір показує вік кожної блискавки за останні {minutes} хвилин — найновіші білим, найстаріші темно-червоним.",
  "weatherMap.legendNewest": "Найновіші",
  "weatherMap.legendOldest": "Найстаріші",
  "weatherMap.legendStationsHelp": "Колір позначки відображає значення вибраного показника.",
  "weatherMap.lightningDataAttribution": "Дані про блискавки: Blitzortung.org",
  "weatherMap.lightningStrikes": "Удари блискавок",
  "weatherMap.lightningStrikesDescription": "Показувати удари блискавок на карті в реальному часі",
  "weatherMap.mapLayers": "Шари карти",
  "weatherMap.mapLegend": "Легенда карти",
  "weatherMap.radarDataAttribution": "Дані радара: NOAA / EUMETNET OPERA via LibreWXR",
  "weatherMap.rainRadar": "Радар дощу",
  "weatherMap.rainRadarDescription": "Відображення накладення радара дощу на карті",
  "weatherMap.weatherflowNCRain": "NC Rain (Nearcast Rain)",
  "weatherMap.weatherflowNCRainDescription": "NC Rain — це додаткове джерело даних, яке надається через систему Tempest Weather System на основі технології Nearcast. Дані NC Rain – це оцінка середньої кількості опадів навколо вашого Tempest на рівні околиць",
  "weatherMap.weatherMap": "Карта погоди",
  "weatherMap.weatherMapMetaDescription": "SmartMixin пропонує інтерактивні карти погоди та радарні карти для метеорологічних умов по всьому світу.",
  "weatherWarnings.activeNow": "Діють зараз",
  "weatherWarnings.fromTime": "З {time}",
  "weatherWarnings.hazardAirQuality": "Якість повітря",
  "weatherWarnings.hazardAvalanche": "Лавини",
  "weatherWarnings.hazardCoastalEvent": "Прибережні небезпеки",
  "weatherWarnings.hazardFlood": "Повені",
  "weatherWarnings.hazardFog": "Туман",
  "weatherWarnings.hazardForestFire": "Лісові пожежі",
  "weatherWarnings.hazardHighTemperature": "Високі температури",
  "weatherWarnings.hazardLowTemperature": "Низькі температури",
  "weatherWarnings.hazardOther": "Інша небезпека",
  "weatherWarnings.hazardRain": "Дощ",
  "weatherWarnings.hazardSnowIce": "Сніг і ожеледь",
  "weatherWarnings.hazardThunderstorm": "Грози",
  "weatherWarnings.hazardUv": "УФ-випромінювання",
  "weatherWarnings.hazardWind": "Вітер",
  "weatherWarnings.lastUpdate": "Останнє оновлення: {time}",
  "weatherWarnings.severityExtreme": "Екстремальний",
  "weatherWarnings.severityFrom": "{severity} з {time}",
  "weatherWarnings.severityMinor": "Низький",
  "weatherWarnings.severityModerate": "Помірний",
  "weatherWarnings.severityNow": "{severity} зараз",
  "weatherWarnings.severitySevere": "Серйозний",
  "weatherWarnings.severityUntil": "{severity} до {time}",
  "weatherWarnings.source": "Джерело: {source}",
  "weatherWarnings.spokenHazardOne": "{hazard}: {status}.",
  "weatherWarnings.spokenHazardTwo": "{hazard}: {first}, потім {second}.",
  "weatherWarnings.spokenLabel": "{count, plural, one {# офіційне попередження про погоду} few {# офіційні попередження про погоду} many {# офіційних попереджень про погоду} other {# офіційного попередження про погоду}}. {hazards}",
  "weatherWarnings.upcoming": "Очікуються"
}
